import { ChartColumn, Download, Ellipsis, Trash2, Undo2 } from 'lucide-react';
import axios from 'axios';
import React from 'react';
import { Cookies } from 'react-cookie';
import { useHistory } from 'react-router';
import { useRecoilState, useRecoilValue } from 'recoil';
import styled from 'styled-components';
import { ACampaigns, Campaign, getCampaings } from '../../atoms/campaignAtom';
import { ACompanies, getClientCompanies } from '../../atoms/clientCompany';
import { AUsers, getUsers } from '../../atoms/global/users';
import { AProducts, getProducts } from '../../atoms/product';
import Dropdown from '../../components_v2/dropdown/Dropdown';
import DropdownColor from '../../components_v2/dropdown/DropdownColors';
import { DropdownData, DropdownStyle } from '../../components_v2/dropdown/model/Model';
import Input from '../../components_v2/input/Input';
import InputImage from '../../components_v2/input/InputImage';
import { PopupMode } from '../../components_v2/popup/model/Model';
import Popup from '../../components_v2/popup/Popup';
import PopupCreation, { ButtonStyle } from '../../components_v2/popup/PopupCreation';
import { PanelSelector } from '../../components_v2/Selector/PanelSelector';
import { URL_FOUNDATION } from '../../config/keys';

import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { AtomCategory } from '../../atoms/utils/model/Model';
import Add from '../../components_v2/add/Add';
import { InputStyle } from '../../components_v2/input/model/Model';
import { PanelContext } from '../../components_v2/panel/context';
import { OnDateChangeType, RawDatePicker } from '../../components_v2/toolbarFilter/time/DatePicker';
import ToolbarFilterButton from '../../components_v2/toolbarFilter/ToolbarButton';
import ToolbarFilter, { ToolbarElement } from '../../components_v2/toolbarFilter/ToolbarFilter';
import { isSuperAdmin } from '../../components_v2/utils';
import RefreshButton from '../../myToolbar/RefreshButton';
import { AiButton, DefaultButton } from '../../styles/global/css/GlobalButton';
import { Loader } from '../../styles/global/css/GlobalLoader';
import {
	PrimaryColor,
	BorderColor,
	DarkGreySidely2,
	GreySidely3,
	LightGreySidely,
	PastelPrimaryColor,
	RedSidely,
	SidelyBlack,
	SurfaceColor
} from '../../styles/global/css/Utils';
import { Translate, translateToString } from '../../styles/global/translate';
import { chartToAiArchive, dashboardToAiArchive, toAiDataFilters } from '../ai/aiArchives';
import { AiIcon } from '../ai/aiChatView';
import { AlertContext, AlertRes } from '../alert/AlertProvider';
import { getGroups } from '../authorization/action';
import { Group } from '../authorization/model';
import { Column, ColumnOrganizer, TitleAndChild } from '../client-companies/popup/ColumnOrganizer';
import { creationPopupInputStyle } from '../../components_v2/popup/style/CreationFormStyle';
import { getClientCompanyByUuid } from '../forms/actions';
import { BoolCheckbox } from '../forms/PopupField';
import { launchToastError } from '../forms/visual-form-editor/visualFormEditor';
import { ToolbarImageContainer } from '../globals/defaultToolbar/style/Style';
import { ComponentProps } from '../globals/mainPage/mainPage';
import { LoadingStateEnum } from '../import/model';
import PermissionContext from '../permissions/PermissionContext';
import Restricted from '../permissions/Restricted';
import { FlexDiv } from '../products/style';
import { getReportById, getReports, Report } from '../reports/action';
import { Cell, Report as ComputedReport, Header, Row } from '../reports/interpretor/bareReportingDecoder';
import { valueToString } from '../reports/interpretor/ReportInterpretor';
import { getLanguage } from '../reports/utils';
import { CreationEditionOrDeletion, DandDDots } from '../settings/subSettings/statusesAndTagsSettings';
import { bulkPutDashboards, CHART_GRANULARITIES, CHART_ORIENTATIONS, CHART_REPRESENTATIONS, CHART_SORT_ORDERS, ChartData, ChartRepresentation, Dashboard, DASHBOARD_TYPES, DashboardChartConfig, DashboardChartConfigWithChartData, DashboardType, deleteChart, deleteDashboard, getCharts, getDashboards as getDashboardsWeb, IMAGE_FITS, isSingleValueChart, isStaticChart, postChart, postDashboard, putChart, PutDashboard, putDashboard, TEXT_ALIGNMENTS, TEXT_SIZES } from './action';
import { CHART_HEIGHT, chartBackgroundColor, createStaticWidget, DashboardState, exportChartAsPng, generateChartSvg, GenerateChartSvgProps, getDashboards, getReport, GroupedValueNameData, init, ValueNameData, valueToString as valueToStringWithContext } from './cross_platform/dashboard_script';
import { getGoalsAndGenerateTree, GoalTree } from './cross_platform/goals';
import { MandatoryModalState } from '../products/model';
import AllowDenyListPopup from '../allow-deny-list/popup';
import { canUserAccess } from '../../atoms/allowDenyList';
import RestrictedAllowDenyList from '../permissions/RestrictedAllowDenyList';

interface ElementWithCleanup extends Element {
	_cleanupTooltip?: () => void;
}

const SharedContainer = styled.div`
    .chart-options-dropdown {
        position: absolute;
        top: 30px;
        right: 0px;
        background-color: ${SurfaceColor};
        border: 1px solid ${BorderColor};
        border-radius: 8px;
        padding: 4px;
        box-shadow: 0 4px 12px color-mix(in oklab, ${SidelyBlack} 10%, transparent);
        z-index: 1000;
        min-width: 140px;
        display: none;
    }
    .chart-options-dropdown-item {
        padding: 6px 10px;
        cursor: pointer;
        white-space: nowrap;
        font-size: 13px;
        border-radius: 6px;
        &:hover {
            background-color: ${LightGreySidely};
        }
    }
    .chart-menu-button:hover {
        background-color: ${LightGreySidely};
    }
    .card-number .chart-title {
        font-size: 12px;
        font-weight: 500;
        color: ${DarkGreySidely2};
    }
`;

const Container = styled(SharedContainer)`
    --primary-color: ${PrimaryColor};
    --on-primary-color: white;
    --surface-color: ${SurfaceColor};
    --on-surface-color: ${SidelyBlack};
    background-color: ${SurfaceColor};
    color: ${SidelyBlack};
    font-family: Inter, sans-serif;
	height: calc(100vh - 130px);
	overflow: auto;
    .card {
        background-color: var(--surface-color);
        border-radius: 10px;
        padding: 16px 18px;
        border: 1px solid ${BorderColor};
    }
    .dashboard {
        gap: 12px;
        grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
        grid-auto-rows: minmax(${CHART_HEIGHT / 2}px, auto);
        grid-auto-flow: dense;
        display: grid;
        height: 100%;
        width: 100%;
    }
	@media (max-width: 800px) {
		.dashboard .card {
			grid-column: span 1 !important;
		}
	}
`;

const MobileContainer = styled(SharedContainer)`
    .dashboard {
		height: 100%;
        width: 100%;
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
        grid-auto-rows: minmax(${CHART_HEIGHT / 2}px, auto);
        grid-auto-flow: dense;
        @media (max-width: 800px) {
			grid-template-columns: 1fr !important;
          	.card {
				grid-column: span 1 !important;
			}
        }
    }
`;

const DropdownDashboardCreationStyle: DropdownStyle = {
	width: '100%',
	optionWidth: '42vw',
	optionHeight: '200px',
	containerWidth: '100%'
};

const DashboardEditDropdown = styled.div<{ $top: number; $left: number }>`
	position: fixed;
	z-index: 1000;
	top: ${props => props.$top}px;
	left: ${props => props.$left}px;
	background-color: var(--surface-color);
	border: 1px solid ${BorderColor};
	border-radius: 4px;
	box-shadow: 0 2px 10px color-mix(in oklab, ${SidelyBlack} 10%, transparent);
	padding: 4px;
`;

const DashboardEditDropdownOption = styled.div`
	padding: 4px 8px;
	cursor: pointer;
	border-radius: 5px;
	&:hover {
		background-color: ${PastelPrimaryColor};
	}
`;

function DropdownMenu({ dashboard, onEditDashboard, onDeleteDashboard, onAddRestrictions }: { dashboard: Dashboard; onEditDashboard?: (uuid: string) => void; onDeleteDashboard?: (uuid: string) => void; onAddRestrictions?: (uuid: string) => void }) {
	const [isOpen, setIsOpen] = React.useState(false);
	const [position, setPosition] = React.useState({ top: 0, left: 0 });
	const containerRef = React.useRef<HTMLDivElement>(null);

	const handleClick = (e: React.MouseEvent) => {
		e.stopPropagation();
		if (containerRef.current) {
			const rect = containerRef.current.getBoundingClientRect();
			setPosition({
				top: rect.bottom + 5,
				left: rect.right - 80
			});
		}
		setIsOpen(!isOpen);
	};

	React.useEffect(() => {
		if (!isOpen) return;

		const handleClickOutside = (e: MouseEvent) => {
			if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
				setIsOpen(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, [isOpen]);

	return <div style={{ cursor: 'pointer' }} ref={containerRef} onClick={handleClick}>
		<Ellipsis color={GreySidely3} strokeWidth={2.5} size={15} />
		{isOpen && (
			<DashboardEditDropdown $top={position.top} $left={position.left}>
				<DashboardEditDropdownOption onClick={() => {
					onEditDashboard?.(dashboard.uuid);
					setIsOpen(false);
				}}>
					{translateToString('edit')}
				</DashboardEditDropdownOption>
				{onAddRestrictions && <DashboardEditDropdownOption onClick={() => {
					onAddRestrictions?.(dashboard.uuid);
					setIsOpen(false);
				}}>
					{translateToString('allow_deny_list.restrictions')}
				</DashboardEditDropdownOption>}
				<DashboardEditDropdownOption onClick={() => {
					onDeleteDashboard?.(dashboard.uuid);
					setIsOpen(false);
				}}>
					{translateToString('delete')}
				</DashboardEditDropdownOption>
			</DashboardEditDropdown>
		)}
	</div>;
}

function InnerDashboard(props: {
	refresh?: boolean,
	companyId?: number,
	userId?: number,
	filterDates?: OnDateChangeType,
	maxDashboardsNb?: number,
	onEditChart?: (value) => void,
	onCreateDashboard?: () => void,
	onCreateChart?: (dashboardUuid) => void,
	onEditDashboard?: (value: string) => void,
	onDeleteDashboard?: (value: string) => void,
	onSeeReport?: (report_id: number) => void,
	onAiChat?: (chart: DashboardChartConfigWithChartData, data: (ValueNameData | GroupedValueNameData[])[]) => void,
	onChartDataLoad?: (uuid: string, data: (ValueNameData | GroupedValueNameData[])[]) => void,
	onDashboardChange?: (dashboard: Dashboard) => void,
	onRemoveChart?: (dashboard_uuid: string, chart_uuid: string) => void,
	onDuplicateChart?: (dashboard_uuid: string, chart_uuid: string) => void,
	onOpenFullscreen?: (props: GenerateChartSvgProps) => void,
	maxCharts?: number,
	onAddRestrictions?: (value: string) => void,
	isMobile?: boolean
}): JSX.Element {
	const [companyId, setCompanyId] = React.useState<number | undefined>(props.companyId);
	const [token, setToken] = React.useState<string | undefined>(undefined);
	const canUserAccessFn = canUserAccess();
	const history = useHistory();
	const query = new URLSearchParams(history.location.search);
	const cookies = new Cookies();
	// if (!axios.defaults.headers.common.Authorization) axios.defaults.headers.common.Authorization = `Bearer ${token ?? ''}`;
	const [dashboards, setDashboards] = React.useState<Dashboard[]>([]);
	const [users, setUsers] = useRecoilState(AUsers);
	const [products, setProducts] = useRecoilState(AProducts);
	const [companies, setCompanies] = useRecoilState(ACompanies);
	const [campaigns, setCampaigns] = useRecoilState(ACampaigns);
	const [selectedDashboard, setSelectedDashboard] = React.useState<Dashboard>();
	const [panels, setPanels] = React.useState<{ label: React.ReactNode, imgJsx?: JSX.Element, dashboard: Dashboard }[]>([]);

	React.useEffect(() => {
		const containerElement = document.getElementById('dashboard-container-queries');
		if (containerElement) {
			const asyncCall = async() => {
				const style = document.createElement('style');
				style.innerHTML = `
				@container dashboard (max-width: 800px) {
					.card {
						grid-column: span 1 !important;
					}
				}
			`;
				containerElement.appendChild(style);

				// init companyId + token
				const token = query.get('token') ?? (cookies.get('id_token') as string | undefined)?.split(' ')[1];
				axios.defaults.headers.common.Authorization = `Bearer ${token ?? ''}`;
				if (users.length == 0) {
					setUsers(await getUsers());
				}
				axios.defaults.headers.common.Authorization = `Bearer ${token ?? ''}`;
				if (products.length == 0) {
					setProducts(await getProducts());
				}
				axios.defaults.headers.common.Authorization = `Bearer ${token ?? ''}`;
				if (Object.keys(companies).length == 0) {
					setCompanies(await getClientCompanies().then(a => a.reduce((acc, [id, name]) => {
						acc[id] = name;
						return acc;
					}, {} as Record<number, string>)));
				}
				axios.defaults.headers.common.Authorization = `Bearer ${token ?? ''}`;
				if (Object.keys(campaigns).length == 0) {
					setCampaigns(await getCampaings().then(a => a.reduce((acc, c) => {
						acc[c.id] = c;
						return acc;
					}, {} as Record<number, Campaign>)));
				}
				const queryCompanyUuid = query.get('company_uuid');
				axios.defaults.headers.common.Authorization = `Bearer ${token ?? ''}`;
				if (queryCompanyUuid) {
					const company = await getClientCompanyByUuid(queryCompanyUuid);
					setCompanyId(company.company_id);
				} else {
					setCompanyId(props.companyId);
				}
				setToken(token);

			};
			asyncCall();

			return () => {
				const styleElement = containerElement?.querySelector('style');
				if (styleElement) {
					styleElement.remove();
				}
			};
		}
	}, []);

	React.useEffect(() => {
		if (!token) return;
		getDashboards(URL_FOUNDATION, token, companyId ? 'company' : 'dashboard').then(rawDashboards => {
			const dashboards = rawDashboards.filter(d => canUserAccessFn('ReadDashboard', undefined, d.uuid));

			const panelData: { label: React.ReactNode, imgJsx?: JSX.Element, dashboard: Dashboard }[] = props.onEditDashboard ?
				dashboards.sort((a, b) => a.sequence - b.sequence)
					.map(dashboard => ({
						dashboard,
						label: dashboard.name,
						imgJsx: <DropdownMenu dashboard={dashboard} onEditDashboard={props.onEditDashboard} onDeleteDashboard={props.onDeleteDashboard} onAddRestrictions={props.onAddRestrictions} />
					}))
				:
				dashboards.sort((a, b) => a.sequence - b.sequence).map(dashboard => ({ label: dashboard.name, dashboard }));
			setPanels(panelData);
			if (dashboards.length > 0) {
				const newSelectedDashboard = dashboards.find(d => d.uuid === selectedDashboard?.uuid) ?? dashboards[0];
				setSelectedDashboard(newSelectedDashboard);
				props.onDashboardChange?.(newSelectedDashboard);
				setDashboards(dashboards);
			}
		});
	}, [props.refresh, token]);

	React.useEffect(() => {
		if (!token) return;
		init({
			dashboard: selectedDashboard ?? dashboards[0],
			foundationUrl: URL_FOUNDATION,
			authToken: token,
			users: new Map(users.map(user => [user.id, user.name])),
			products: new Map(products.map(product => [product.uuid, product.name])),
			companies: new Map(Object.entries(companies).map(([key, value]) => [parseInt(key), value])),
			campaigns: new Map(Object.entries(campaigns).map(([key, value]) => [parseInt(key), value.name])),
			onCreateChart: props.onCreateChart,
			onEditChart: props.onEditChart,
			onSeeReport: props.onSeeReport,
			onAiChat: props.onAiChat,
			onChartDataLoad: props.onChartDataLoad,
			onRemoveChart: props.onRemoveChart,
			companyId,
			userId: props.userId,
			filterDates: props.filterDates,
			onDuplicateChart: props.onDuplicateChart,
			rawProducts: products,
			onOpenFullscreen: props.onOpenFullscreen,
			canExportChart: !props.isMobile,
			locale: getLanguage(),
			maxCharts: props.maxCharts,
			isMobile: props.isMobile,
		});
	}, [selectedDashboard, products, users, companies, campaigns, token, panels]);

	return <>
		<div style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: SurfaceColor, padding: '8px 16px 0' }}>
			<PanelSelector
				panels={panels}
				activeIndex={panels.findIndex((panel) => panel.label === selectedDashboard?.name)}
				onClick={(panel) => {
					setSelectedDashboard(panel.dashboard);
					props.onDashboardChange?.(panel.dashboard);
				}}
				onAddPanel={props.onCreateDashboard}
				imgOnTheRight
				imgOnlyOnActive
				pill
				noToolTip
				disableAddPanel={props.maxDashboardsNb ? dashboards.length >= props.maxDashboardsNb : false}
				disableAddPanelMsg={translateToString('dashboard.creation_disabled', [['MAX_DASHBOARDS', props.maxDashboardsNb ? props.maxDashboardsNb.toString() : '3']])}
			/>
		</div>
		<div id='dashboard-container-queries'>
			<div id='dashboard' style={{ height: '100%', width: '100%', padding: '12px 16px 16px' }} />
		</div>
	</>;
}

const DashboardCreateContainer = styled.div<{ centered?: boolean, margin?: string }>`
	display: flex;
	${p => p.centered ? 'align-items: center;' : ''}
	flex-direction: column;
	gap: 16px;
	${p => p.margin ? `margin: ${p.margin};` : ''}
	height: 100%;
	width: 100%;
	overflow-y: auto;
	padding: 0 20px;
`;

const InputLabel = styled.p<{ required?: boolean, section?: boolean, width?: string, description?: boolean, noPadding?: boolean }>`
	font-size: 13px;
	color: ${DarkGreySidely2};
	display: flex;
  	align-items: center;
  	gap: 5px;
   	margin: 0;
	padding: ${p => p.noPadding ? '0' : '0 0 5px 0'};
    ${p => p.description ? '' : 'font-weight: 500;'}
	${p => p.width ? `width: ${p.width};` : ''}
	${p => p.required ? `&:before {
		content: '*';
		color: ${RedSidely};
	}` : ''}
	${p => p.section ? `
		color: ${SidelyBlack};
		padding: 10px 0;
		margin: 8px 0;
		border-top: 1px solid ${BorderColor};
		font-size: 14px;
		font-weight: 600;
	` : ''}
`;

const PreviewTitle = styled.div`
	font-size: 14px;
	font-weight: 600;
	color: ${DarkGreySidely2};
`;

const ManageDashboardCard = styled.div`
	display: flex;
	justify-content: space-between;
	font-size: 13px;
	border: 1px solid ${BorderColor};
	padding: 16px 8px;
	border-radius: 6px;
	background-color: ${SurfaceColor};
`;

function valueToEditionOrDeletionUuids<T extends { id: string, deleted?: boolean }>(value: T): CreationEditionOrDeletion<T, T> {
	if (value.deleted && 'id' in value) {
		return {
			Deletion: value.id
		};
	}
	if (value.deleted) throw 'deletion of uncreated value';
	return {
		Edition: {
			id: value.id,
			value: { ...value, id: undefined }
		}
	};
}

function ManageDashboardsPopup(props: {
	dashboards: Dashboard[],
	onClose: () => void,
	onSubmit: () => void,
	onEditDashboard: (uuid: string) => void,
	setPopupOpen: (popupMode: 'chart' | 'dashboard' | 'manage_charts' | 'manage_dashboards' | null) => void,
	setDashboardTypeToOpen: (type: 'company' | 'dashboard') => void,
	maxDashboardsNb?: number
}): JSX.Element {
	const [generalDashboards, setGeneralDashboards] = React.useState<(Dashboard & { deleted?: boolean })[]>([]);
	const [otherDashboards, setOtherDashboards] = React.useState<(Dashboard & { deleted?: boolean })[]>([]);
	const isGeneralCreationAllowed = props.maxDashboardsNb ? generalDashboards.filter(d => d.type === 'dashboard').length < props.maxDashboardsNb : true;
	const isOtherCreationAllowed = props.maxDashboardsNb ? otherDashboards.filter(d => d.type !== 'dashboard').length < props.maxDashboardsNb : true;
	const dashboardOptionsDataList: DropdownData[] = [{ value: 'edit', label: translateToString('edit') }];

	React.useEffect(() => {
		setGeneralDashboards(props.dashboards.filter(d => d.type === 'dashboard'));
		setOtherDashboards(props.dashboards.filter(d => d.type !== 'dashboard'));
	}, [props.dashboards]);

	function onDragEnd(dashboards: (Dashboard & { deleted?: boolean })[], setDashboard: React.Dispatch<React.SetStateAction<(Dashboard & { deleted?: boolean })[]>>) {
		return ({ source, destination }) => {
			if (!destination || !source || source.index === destination.index) return;
			const undeleted = dashboards
				.filter(d => !d.deleted)
				.sort((a, b) => a.sequence - b.sequence)
				.map(d => ({ ...d }));
			const [removed] = undeleted.splice(source.index, 1);
			if (!removed) return;
			undeleted.splice(destination.index, 0, removed);
			undeleted.forEach((d, index) => {
				d.sequence = index + 1;
			});
			const deleted = dashboards.filter(d => d.deleted).map(d => ({ ...d }));
			const newDashboards = [...undeleted, ...deleted];

			setDashboard(newDashboards);
		};
	}

	function ManageDashboardCardContent(props: {
		dashboards: (Dashboard & { deleted?: boolean })[],
		setDashboards: (dashboards: (Dashboard & { deleted?: boolean })[]) => void,
		dashboard: Dashboard,
		onEditDashboard: (uuid: string) => void,
		draggable?: boolean,
	}): JSX.Element {
		return <>
			<FlexDiv gap='8px'>
				{props.draggable && <DandDDots />}
				<div>{props.dashboard.name}</div>
			</FlexDiv>
			<FlexDiv gap='8px'>
				<Dropdown
					name={'options_dashboard'}
					datalist={dashboardOptionsDataList}
					dropdownStyle={{ optionLeft: '-140px', optionWidth: '160px', optionHeight: '200px' }}
					searchable={false}
					JSXButton={() => <div style={{ cursor: 'pointer' }}>
						<Ellipsis strokeWidth={2.5} size={14} />
					</div>}
					onChange={(value) => {
						switch (value.value) {
							case 'edit':
								props.onEditDashboard(props.dashboard.uuid);
								break;
						}
					}}
				/>
				<div style={{ cursor: 'pointer' }}>
					<Trash2 color={RedSidely} size={14} onClick={() => {
						const newDashboards = [...props.dashboards];
						newDashboards.forEach(d => {
							if (d.uuid === props.dashboard.uuid) {
								d.deleted = true;
							}
						});
						newDashboards.filter(d => !d.deleted).forEach((d, index) => {
							d.sequence = index + 1;
						});
						props.setDashboards(newDashboards);
					}}
					/>
				</div>
			</FlexDiv>
		</>;
	}

	return <PopupCreation title={translateToString('dashboard.manage_dashboards')}
		content={
			<FlexDiv gap='16px' flow='column' align='stretch'>
				<DragDropContext onDragEnd={onDragEnd(generalDashboards, setGeneralDashboards)}>
					<Droppable droppableId="dashboards_list">
						{(provided): React.ReactElement<HTMLElement> => (
							<DashboardCreateContainer {...provided.droppableProps} innerRef={provided.innerRef}>
								<FlexDiv gap='8px'>
									<div style={{ fontSize: 14, fontWeight: 600 }}>{translateToString('dashboard.dashboard_types.dashboard')}</div>
									<Add disabled={!isGeneralCreationAllowed} size='18px' onClick={isGeneralCreationAllowed ?
										() => {
											props.setDashboardTypeToOpen('dashboard');
											props.setPopupOpen('dashboard');
										} :
										() => {
											launchToastError(translateToString('dashboard.creation_disabled', [['MAX_DASHBOARDS', props.maxDashboardsNb ? props.maxDashboardsNb.toString() : '3']]));
										}
									} />
								</FlexDiv>
								{generalDashboards.filter(d => !d.deleted).sort((a, b) => a.sequence - b.sequence)
									.map((dashboard, index) =>
										<Draggable key={dashboard.uuid} draggableId={dashboard.uuid} index={index}>
											{(provided): React.ReactElement<HTMLElement> => (
												<RestrictedAllowDenyList target='ReadDashboard' target_uuid={dashboard.uuid} fallback={<div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} />}>
													<ManageDashboardCard innerRef={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} >
														<ManageDashboardCardContent dashboards={generalDashboards} setDashboards={setGeneralDashboards} dashboard={dashboard} onEditDashboard={props.onEditDashboard} draggable />
													</ManageDashboardCard>
												</RestrictedAllowDenyList>
											)}
										</Draggable>
									)}
								{provided.placeholder}
							</DashboardCreateContainer>
						)}
					</Droppable>
				</DragDropContext>
				<FlexDiv flow='column' align='stretch' gap='8px'>
					<DragDropContext onDragEnd={onDragEnd(otherDashboards, setOtherDashboards)}>
						<Droppable droppableId="dashboards_others_list">
							{(provided): React.ReactElement<HTMLElement> => (
								<DashboardCreateContainer {...provided.droppableProps} innerRef={provided.innerRef}>
									{otherDashboards.length > 0 && <FlexDiv gap='8px'>
										<div style={{ fontSize: 14, fontWeight: 600 }}>{translateToString('dashboard.dashboard_types.company_dashboard')}</div>
										<Add size='18px' disabled={!isOtherCreationAllowed} onClick={isOtherCreationAllowed ?
											() => {
												props.setDashboardTypeToOpen('company');
												props.setPopupOpen('dashboard');
											} :
											() => {
												launchToastError(translateToString('dashboard.creation_disabled', [['MAX_DASHBOARDS', props.maxDashboardsNb ? props.maxDashboardsNb.toString() : '3']]));
											}
										} />
									</FlexDiv>}
									{otherDashboards.filter(d => !d.deleted).sort((a, b) => a.sequence - b.sequence).map((dashboard, index) =>
										<Draggable key={dashboard.uuid} draggableId={dashboard.uuid} index={index}>
											{(provided): React.ReactElement<HTMLElement> => (
												<ManageDashboardCard innerRef={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} >
													<ManageDashboardCardContent dashboards={otherDashboards} setDashboards={setOtherDashboards} dashboard={dashboard} onEditDashboard={props.onEditDashboard} draggable />
												</ManageDashboardCard>
											)}
										</Draggable>
									)}
									{provided.placeholder}
								</DashboardCreateContainer>
							)}
						</Droppable>
					</DragDropContext>
				</FlexDiv>
			</FlexDiv>
		}
		canValidate={true}
		messageButton={translateToString('save')}
		onSubmit={() => {
			const dashboardsToSync: CreationEditionOrDeletion<PutDashboard>[] = [...generalDashboards.map(d => {
				return valueToEditionOrDeletionUuids({ id: d.uuid, sequence: d.sequence, deleted: d.deleted });
			}), ...otherDashboards.map(d => {
				return valueToEditionOrDeletionUuids({ id: d.uuid, sequence: d.sequence, deleted: d.deleted });
			})];
			bulkPutDashboards(dashboardsToSync).then(() => {
				props.onSubmit();
				props.onClose();
			});
		}}
		onClose={props.onClose}
	/>;
}

function ManageChartsPopup(props: {
	onClose: () => void,
	onSubmit: () => void,
	onEditChart: (uuid: string) => void,
	onCreateChart: (chartType: ChartRepresentation) => void,
	onDuplicateChart: (chart_uuid: string) => void,
}): JSX.Element {
	const [charts, setCharts] = React.useState<DashboardChartConfigWithChartData[]>([]);
	const chartsByRepresentation: { [key: string]: DashboardChartConfigWithChartData[] } = charts.reduce((acc, chart) => {
		if (!acc[chart.representation]) {
			acc[chart.representation] = [];
		}
		acc[chart.representation].push(chart);
		return acc;
	}, {} as { [key: string]: DashboardChartConfigWithChartData[] });
	const [refresh, setRefresh] = React.useState(false);
	const chartOptionsDataList: DropdownData[] = [
		{ value: 'edit', label: translateToString('edit') },
		{ value: 'duplicate', label: translateToString('dashboard.duplicate_chart') },
		{ value: 'delete', label: translateToString('delete') }
	];
	const { alert } = React.useContext(AlertContext);

	React.useEffect(() => {
		getCharts().then(charts => {
			setCharts(charts);
		});
	}, [refresh]);

	return <PopupCreation title={translateToString('dashboard.manage_charts')}
		hideValidation
		content={<DashboardCreateContainer>
			{Object.keys(chartsByRepresentation).map(representation =>
				<FlexDiv flow='column' align='stretch' gap='8px' key={`chart_representation_section[${representation}]`}>
					<FlexDiv fontSize='14' fontWeight='600' gap='8px'>
						{translateToString(`dashboard.representations.${representation}`)}
						<Add size='18px' onClick={() => {
							props.onCreateChart(representation as ChartRepresentation);
						}} />
					</FlexDiv>
					{chartsByRepresentation[representation].sort((a, b) => a.name?.localeCompare(b.name ?? '') ?? 0)
						.map(chart => <ManageDashboardCard key={chart.uuid}>
							<FlexDiv>{chart.name ?? translateToString('dashboard.unnamed_chart')}</FlexDiv>
							<Dropdown
								name={`options_${chart.uuid}`}
								datalist={chartOptionsDataList}
								dropdownStyle={{ optionLeft: '-140px', optionWidth: '160px', optionHeight: '200px' }}
								searchable={false}
								JSXButton={() => <div style={{ cursor: 'pointer' }}>
									<Ellipsis strokeWidth={2.5} size={14} />
								</div>}
								onChange={(value) => {
									switch (value.value) {
										case 'edit':
											props.onEditChart(chart.uuid);
											break;
										case 'duplicate':
											props.onDuplicateChart(chart.uuid);
											setRefresh(prev => !prev);
											break;
										case 'delete':
											alert({
												title: translateToString('dashboard.delete_chart'),
												content: translateToString('dashboard.confirm_delete_chart'),
												buttons: [{ title: translateToString('delete'), res: AlertRes.Ok, style: ButtonStyle.Error }],
												zIndex: 1200
											}).then(res => {
												if (res.res === AlertRes.Ok) {
													deleteChart(chart.uuid).then(() => {
														setCharts(charts.filter(c => c.uuid !== chart.uuid));
														props.onSubmit();
													});
												}
											});
									}
								}}
							/>
						</ManageDashboardCard>)}
				</FlexDiv>
			)}
		</DashboardCreateContainer>
		}
		onClose={props.onClose}
	/>;
}

function CreateDashboardPopup(props: {
	dashboards: Dashboard[],
	maxDashboardsNb?: number,
	maxChartsNb?: number,
	onClose: () => void,
	onSubmit: () => void,
	dashboardToEdit?: Dashboard,
	dashboardType?: DashboardType
}): JSX.Element {
	const [linkedCharts, setLinkedCharts] = React.useState<DashboardChartConfigWithChartData[]>([]);
	const [dashboardName, setDashboardName] = React.useState<string>('');
	const [dashboardType, setDashboardType] = React.useState<DashboardType | undefined>(props.dashboardType ?? undefined);
	const [charts, setCharts] = React.useState<DashboardChartConfigWithChartData[]>([]);
	const [dashboardToEdit, setDashboardToEdit] = React.useState<Dashboard | null>(props.dashboardToEdit ?? null);

	React.useEffect(() => {
		getCharts().then(charts => {
			setCharts(charts);
		});
	}, []);

	React.useEffect(() => {
		setDashboardToEdit(props.dashboardToEdit ?? null);
	}, [props.dashboardToEdit]);

	React.useEffect(() => {
		if (dashboardToEdit) {
			setDashboardName(dashboardToEdit.name);
			setLinkedCharts(dashboardToEdit.charts);
			setDashboardType(dashboardToEdit.type);
		}
	}, [dashboardToEdit]);

	const chartByRepresentation = React.useMemo(() => {
		const chartsByRep = charts.reduce((acc, chart) => {
			if (!acc[chart.representation]) {
				acc[chart.representation] = [];
			}
			acc[chart.representation].push({ ...chart, sequence: linkedCharts.find(linkedChart => linkedChart.uuid === chart.uuid)?.sequence ?? Number.POSITIVE_INFINITY });
			return acc;
		}, {} as { [key: string]: (DashboardChartConfigWithChartData & { sequence: number })[] });
		return Object.keys(chartsByRep).map(representation => ({
			category: representation,
			columns: chartsByRep[representation].map(chart => ({
				value: chart.uuid,
				label: chart.name ?? translateToString('dashboard.unnamed_chart'),
				checked: linkedCharts.some(linkedChart => linkedChart.uuid === chart.uuid),
				sequence: chart.sequence,
				categoryIndex: 0
			}))
		}));
	}, [charts, linkedCharts]);

	function resetState() {
		setDashboardToEdit(null);
		setDashboardName('');
		setLinkedCharts([]);
	}

	return <PopupCreation title={props.dashboardToEdit ? translateToString('dashboard.edit_dashboard') : translateToString('dashboard.create_dashboard')}
		content={<DashboardCreateContainer>
			<FlexDiv gap='8px' width='100%'>
				<div style={{ width: '100%' }}>
					<InputLabel required>{translateToString('dashboard.name')}</InputLabel>
					<Input
						name='dashboard_name'
						type='text'
						inputStyle={creationPopupInputStyle}
						placeholder={translateToString('dashboard.dashboard_name_placeholder')}
						value={dashboardName}
						onChange={(value: string) => setDashboardName(value)}
					/>
				</div>
				<div style={{ width: '100%' }}>
					<InputLabel required>{translateToString('dashboard.dashboard_type')}</InputLabel>
					{!props.dashboardToEdit ?
						<Dropdown
							name='dashboard_type'
							datalist={
								DASHBOARD_TYPES.map(type => ({
									value: type,
									label: translateToString(`dashboard.dashboard_type_datalist.${type}`),
									disabled: props.maxDashboardsNb ? props.dashboards.filter(d => d.type === type).length >= props.maxDashboardsNb : false
								}))
							}
							selectedValue={dashboardType ? { value: dashboardType, label: translateToString(`dashboard.dashboard_type_datalist.${dashboardType}`) } : undefined}
							onChange={(value) => {
								setDashboardType(value.value as DashboardType);
							}}
							searchable={false}
							readOnly
							dropdownStyle={DropdownDashboardCreationStyle}

						/>
						:
						<Input
							name='dashboard_type'
							type='text'
							inputStyle={{
								width: '100%',
								containerWidth: '100%',
								padding: '.56rem 0.75rem',
								borderRadius: '5px'
							}}
							disabled
							value={translateToString(`dashboard.dashboard_type_datalist.${dashboardType}`)}
						/>
					}
				</div>
			</FlexDiv>
			<div style={{ fontSize: '12px', height: '85%' }}>
				<ColumnOrganizer
					columnsByCategory={chartByRepresentation}
					setColumnsByCategory={(newChartByRepresentation: { category: string, columns: Column[] }[]) => {
						const newLinkedCharts = newChartByRepresentation
							.flatMap(category => category.columns)
							.filter(column => column.checked)
							.sort((a, b) => a.sequence - b.sequence)
							.reduce((acc: DashboardChartConfigWithChartData[], column, index) => {
								const chart = charts.find(c => c.uuid === column.value);
								if (chart) {
									acc.push({ ...chart, sequence: index });
								}
								return acc;
							}, []);
						setLinkedCharts(newLinkedCharts);
					}}
					translationPath='dashboard.dashboard_edit'
					categoryTranslationPath='dashboard.representations'
					maxSelected={props.maxChartsNb}
				/>
			</div>
			{/* TODO add AI to dashboards */}
			{/*<Restricted to={{ objectAction: 'CreateAi' }}>
				<DashboardSidelyAiCreation
					value={dashboardAiOptions?.instructions}
					onChange={(instructions) => setDashboardAiOptions(options => ({ ...options, instructions }))}
				/>
			</Restricted>*/}
		</DashboardCreateContainer>
		}
		messageButton={props.dashboardToEdit ? translateToString('save') : translateToString('create')}
		canValidate={dashboardName.trim().length > 0 && dashboardType !== undefined && (props.maxChartsNb ? linkedCharts.length <= props.maxChartsNb : true)}
		onSubmit={() => {
			if (dashboardToEdit) {
				putDashboard(dashboardToEdit.uuid, {
					name: dashboardName,
					type: dashboardType ?? 'dashboard',
					charts: linkedCharts.map(chart => ({ uuid: chart.uuid, sequence: chart.sequence })),
					sequence: dashboardToEdit.sequence,
				}).then(() => {
					props.onClose();
					props.onSubmit();
				});
				return;
			}
			postDashboard({
				name: dashboardName,
				type: dashboardType ?? 'dashboard',
				charts: linkedCharts.map(chart => ({ uuid: chart.uuid, sequence: chart.sequence })),
				sequence: props.dashboards.length + 1,
			}).then(() => {
				resetState();
				props.onClose();
				props.onSubmit();
			});
		}}
		onClose={() => {
			resetState();
			props.onClose();
		}}
	/>;
}

function recursiveGetPrimaryCellsForLevel(rows: Row[], groupByIndex: number): Cell[] {
	if (groupByIndex < 0) return [];
	const cells: Map<string, Cell> = new Map();
	if (groupByIndex === 0) {
		for (const row of rows) {
			for (const cell of row.primaryCell) {
				if (cell.value.tag != 15 && cell.value.tag != 16)
					cells.set(valueToString(cell.value) ?? '', cell);
			}
		}
	}
	else {
		for (const row of rows) {
			const childCells = recursiveGetPrimaryCellsForLevel(row.rows, groupByIndex - 1);
			for (const cell of childCells) {
				if (cell.value.tag != 15 && cell.value.tag != 16)
					cells.set(valueToString(cell.value) ?? '', cell);
			}
		}
	}
	return Array.from(cells.values());
}


function DashboardSidelyAiCreation(props: { value: string | undefined, onChange: (value: string) => void }) {
	return <FlexDiv flow='column' align='stretch' width='100%' gap='16px'>
		<hr style={{ borderColor: BorderColor, width: '100%', height: '1px', margin: '0 0 -10px 0' }} />
		<TitleAndChild title='Sidely AI' icon={<AiIcon circle size={27} />} >
			<div style={{ width: '100%' }}>
				<InputLabel description><Translate id='precise_ai_context' /></InputLabel>
				<div style={{ height: '20px' }} />
				<FlexDiv gap='16px' flow='column' align='stretch'>
					<div>
						<InputLabel><Translate id='instructions' /></InputLabel>
						<Input
							placeholder={translateToString('precise_ai_context_placeholder')}
							inputStyle={{
								width: '100%',
								containerWidth: '100%',
								height: '150px',
								padding: '.56rem 0.75rem',
								borderRadius: '5px'
							}}
							textArea
							name='chart_ai_instructions'
							value={props.value}
							onChange={props.onChange}
							type='text'
						/>
					</div>
				</FlexDiv>
			</div>
		</TitleAndChild>
	</FlexDiv>;
}

function NumberOnlyOptions(props: { representation: string, chartData: ChartData, setChartData: (data: ChartData) => void }) {
	const { representation, chartData, setChartData } = props;
	if (representation !== 'number') return null;
	return <>
		<hr style={{ borderColor: BorderColor, width: '100%', height: '1px', margin: '0 0 -10px 0' }} />
		<TitleAndChild title={translateToString('dashboard.representations.number')}>
			<FlexDiv gap='16px' flow='column' align='stretch' width='100%'>
				<div style={{ width: '100%' }}>
					<FlexDiv gap='8px'>
						<BoolCheckbox type='checkbox' checked={chartData.options?.display_line_chart_evolution} onClick={() => setChartData({ ...chartData, options: { ...chartData.options, display_line_chart_evolution: !chartData.options?.display_line_chart_evolution } })} />
						<InputLabel noPadding>{translateToString('dashboard.display_line_chart_evolution')}</InputLabel>
					</FlexDiv>
				</div>
				<div style={{ width: '100%' }}>
					<FlexDiv gap='8px'>
						<BoolCheckbox type='checkbox' checked={chartData.options?.is_percentage} onClick={() => setChartData({ ...chartData, options: { ...chartData.options, is_percentage: !chartData.options?.is_percentage } })} />
						<InputLabel noPadding>{translateToString('dashboard.is_percentage')}</InputLabel>
					</FlexDiv>
				</div>
			</FlexDiv>
		</TitleAndChild>
	</>;
}

function GaugeOnlyOptions(props: { chartData: ChartData, setChartData: (data: ChartData) => void, MarginInputStyle: InputStyle }) {
	const { chartData, setChartData, MarginInputStyle } = props;
	const setBoundary = (key: 'min' | 'max', value: string) => {
		const parsed = value === '' ? undefined : parseFloat(value);
		if (parsed !== undefined && isNaN(parsed)) return;
		setChartData({ ...chartData, options: { ...chartData.options, gauge_boundaries: { ...chartData.options?.gauge_boundaries, [key]: parsed } } });
	};
	return <>
		<hr style={{ borderColor: BorderColor, width: '100%', height: '1px', margin: '0 0 -10px 0' }} />
		<TitleAndChild title={translateToString('dashboard.representations.gauge')}>
			<div style={{ width: '100%' }}>
				<InputLabel>{translateToString('dashboard.gauge_boundaries')}</InputLabel>
				<div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gridTemplateRows: '60px' }}>
					<FlexDiv gap='4px'>
						<InputLabel noPadding width='4vw'>min</InputLabel>
						<Input
							name='gauge_min'
							type='number'
							placeholder='0'
							inputStyle={MarginInputStyle}
							value={chartData.options?.gauge_boundaries?.min}
							onChange={(value: string) => setBoundary('min', value)}
						/>
					</FlexDiv>
					<FlexDiv gap='4px'>
						<InputLabel noPadding width='4vw'>max</InputLabel>
						<Input
							name='gauge_max'
							type='number'
							placeholder='100'
							inputStyle={MarginInputStyle}
							value={chartData.options?.gauge_boundaries?.max}
							onChange={(value: string) => setBoundary('max', value)}
						/>
					</FlexDiv>
				</div>
			</div>
		</TitleAndChild>
	</>;
}

function StaticWidgetOptions(props: { representation: ChartRepresentation, chartData: ChartData, setChartData: (data: ChartData) => void }) {
	const { representation, chartData, setChartData } = props;
	if (representation === 'text') return <>
		<div style={{ width: '100%' }}>
			<InputLabel required>{translateToString('dashboard.text_content')}</InputLabel>
			<Input
				name='widget_text'
				type='text'
				textArea
				inputStyle={{
					width: '100%',
					containerWidth: '100%',
					height: '100px',
					padding: '.56rem 0.75rem',
					borderRadius: '5px'
				}}
				placeholder={translateToString('dashboard.text_content_placeholder')}
				value={chartData.options?.text ?? ''}
				onChange={(value: string) => setChartData({ ...chartData, options: { ...chartData.options, text: value } })}
			/>
		</div>
		<div style={{ width: '100%' }}>
			<InputLabel>{translateToString('dashboard.text_size')}</InputLabel>
			<Dropdown
				name='widget_text_size'
				datalist={TEXT_SIZES.map(size => ({ value: size, label: translateToString(`dashboard.text_sizes.${size}`) }))}
				selectedValue={{ value: chartData.options?.text_size ?? 'medium', label: translateToString(`dashboard.text_sizes.${chartData.options?.text_size ?? 'medium'}`) }}
				searchable={false}
				readOnly
				dropdownStyle={DropdownDashboardCreationStyle}
				onChange={(value) => { if (value) setChartData({ ...chartData, options: { ...chartData.options, text_size: value.value } }); }}
			/>
		</div>
		<div style={{ width: '100%' }}>
			<InputLabel>{translateToString('dashboard.text_align')}</InputLabel>
			<Dropdown
				name='widget_text_align'
				datalist={TEXT_ALIGNMENTS.map(align => ({ value: align, label: translateToString(`dashboard.text_alignments.${align}`) }))}
				selectedValue={{ value: chartData.options?.text_align ?? 'left', label: translateToString(`dashboard.text_alignments.${chartData.options?.text_align ?? 'left'}`) }}
				searchable={false}
				readOnly
				dropdownStyle={DropdownDashboardCreationStyle}
				onChange={(value) => { if (value) setChartData({ ...chartData, options: { ...chartData.options, text_align: value.value } }); }}
			/>
		</div>
	</>;
	if (representation === 'image') return <>
		<div style={{ width: '100%' }}>
			<InputLabel required>{translateToString('dashboard.image_file')}</InputLabel>
			<FlexDiv gap='12px'>
				<InputImage
					size={60}
					compress
					limitMo={2}
					maxWidthOrHeight={1024}
					url={chartData.options?.image}
					onChange={(image) => setChartData({ ...chartData, options: { ...chartData.options, image: image.url } })}
					onError={(error) => launchToastError(error.message)}
				/>
				<InputLabel description noPadding>{translateToString('dashboard.image_hint')}</InputLabel>
			</FlexDiv>
		</div>
		<div style={{ width: '100%' }}>
			<InputLabel>{translateToString('dashboard.image_fit')}</InputLabel>
			<Dropdown
				name='widget_image_fit'
				datalist={IMAGE_FITS.map(fit => ({ value: fit, label: translateToString(`dashboard.image_fits.${fit}`) }))}
				selectedValue={{ value: chartData.options?.image_fit ?? 'contain', label: translateToString(`dashboard.image_fits.${chartData.options?.image_fit ?? 'contain'}`) }}
				searchable={false}
				readOnly
				dropdownStyle={DropdownDashboardCreationStyle}
				onChange={(value) => { if (value) setChartData({ ...chartData, options: { ...chartData.options, image_fit: value.value } }); }}
			/>
		</div>
	</>;
	return null;
}

function LineOnlyOptions(props: { representation: string, chartData: ChartData, setChartData: (data: ChartData) => void }) {
	const { representation, chartData, setChartData } = props;
	if (representation !== 'line') return null;
	return <>
		<hr style={{ borderColor: BorderColor, width: '100%', height: '1px', margin: '0 0 -10px 0' }} />
		<TitleAndChild title={translateToString('dashboard.representations.line')}>
			<FlexDiv gap='16px' flow='column' align='stretch' width='100%'>
				<div style={{ width: '100%' }}>
					<FlexDiv gap='8px'>
						<BoolCheckbox type='checkbox' checked={chartData.options?.color_gradient} onClick={() => setChartData({ ...chartData, options: { ...chartData.options, color_gradient: !chartData.options?.color_gradient } })} />
						<InputLabel noPadding>{translateToString('dashboard.color_gradient')}</InputLabel>
					</FlexDiv>
				</div>
			</FlexDiv>
		</TitleAndChild>
	</>;
}

function PieOnlyOptions(props: { representation: string, chartData: ChartData, setChartData: (data: ChartData) => void }) {
	const { representation, chartData, setChartData } = props;
	if (representation !== 'pie') return null;
	return <>
		<hr style={{ borderColor: BorderColor, width: '100%', height: '1px', margin: '0 0 -10px 0' }} />
		<TitleAndChild title={translateToString('dashboard.representations.pie')}>
			<FlexDiv gap='16px' flow='column' align='stretch' width='100%'>
				<div style={{ width: '100%' }}>
					<InputLabel>{translateToString('dashboard.distance_from_center')}</InputLabel>
					<Input
						name='distance_from_center'
						type='number'
						step={1}
						inputStyle={{
							width: '100%',
							containerWidth: '100%',
							padding: '.56rem 0.75rem',
							borderRadius: '5px'
						}}
						value={chartData.options?.distance_from_center ?? ''}
						onChange={(value: string) => {
							if (value === '') {
								setChartData({ ...chartData, options: { ...chartData.options, distance_from_center: undefined } });
							} else {
								const floatValue = parseFloat(value);
								if (!isNaN(floatValue)) {
									setChartData({ ...chartData, options: { ...chartData.options, distance_from_center: floatValue } });
								}
							}
						}}
					/>
				</div>
				<div style={{ width: '100%' }}>
					<InputLabel>{translateToString('dashboard.min_slice_angle')}</InputLabel>
					<Input
						name='min_slice_angle'
						type='number'
						step={1}
						inputStyle={{
							width: '100%',
							containerWidth: '100%',
							padding: '.56rem 0.75rem',
							borderRadius: '5px'
						}}
						value={chartData.options?.min_slice_angle ?? ''}
						onChange={(value: string) => {
							if (value === '') {
								setChartData({ ...chartData, options: { ...chartData.options, min_slice_angle: undefined } });
							} else {
								const floatValue = parseFloat(value);
								if (!isNaN(floatValue)) {
									setChartData({ ...chartData, options: { ...chartData.options, min_slice_angle: floatValue } });
								}
							}
						}}
					/>
				</div>
				<div style={{ width: '100%' }}>
					<FlexDiv gap='8px'>
						<BoolCheckbox type='checkbox' checked={chartData.options?.doughnut} onClick={() => setChartData({ ...chartData, options: { ...chartData.options, doughnut: !chartData.options?.doughnut } })} />
						<InputLabel noPadding>{translateToString('dashboard.doughnut')}</InputLabel>
					</FlexDiv>
				</div>
				<div style={{ width: '100%' }}>
					<FlexDiv gap='8px'>
						<BoolCheckbox type='checkbox' checked={chartData.options?.hide_value_labels} onClick={() => setChartData({ ...chartData, options: { ...chartData.options, hide_value_labels: !chartData.options?.hide_value_labels } })} />
						<InputLabel noPadding>{translateToString('dashboard.hide_value_labels')}</InputLabel>
					</FlexDiv>
				</div>
			</FlexDiv>
		</TitleAndChild>
	</>;
}

function BarOnlyOptions(props: { representation: string, chartData: ChartData, setChartData: (data: ChartData) => void, isEvolutionReport?: boolean }) {
	const { representation, chartData, setChartData, isEvolutionReport } = props;
	if (representation !== 'bar') return null;
	return <>
		<hr style={{ borderColor: BorderColor, width: '100%', height: '1px', margin: '0 0 -10px 0' }} />
		<TitleAndChild title={translateToString('dashboard.representations.bar')}>
			<FlexDiv gap='16px' flow='column' align='stretch' width='100%'>
				<div style={{ width: '100%' }}>
					<InputLabel>{translateToString('dashboard.orientation')}</InputLabel>
					<Dropdown
						name='chart_oritentation'
						datalist={CHART_ORIENTATIONS.map(rep => ({ value: rep, label: translateToString(`dashboard.orientations.${rep}`) }))}
						selectedValue={chartData.options?.orientation ? { value: chartData.options.orientation, label: translateToString(`dashboard.orientations.${chartData.options.orientation}`) } : undefined}
						searchable={false}
						readOnly
						dropdownStyle={DropdownDashboardCreationStyle}
						onChange={(value) => { if (value) setChartData({ ...chartData, options: { ...chartData.options, orientation: value.value } }); }}
					/>
				</div>
				<div style={{ width: '100%' }}>
					<InputLabel>{translateToString('dashboard.sort')}</InputLabel>
					<Dropdown
						name='chart_sort'
						datalist={CHART_SORT_ORDERS.map(rep => ({ value: rep, label: translateToString(`dashboard.sort_orders.${rep}`) }))}
						selectedValue={chartData.options?.sort ? { value: chartData.options.sort, label: translateToString(`dashboard.sort_orders.${chartData.options.sort}`) } : undefined}
						searchable={false}
						readOnly
						dropdownStyle={DropdownDashboardCreationStyle}
						onChange={(value) => {
							if (value) {
								setChartData({ ...chartData, options: { ...chartData.options, sort: value.value } });
							}
						}}
					/>
				</div>
				{isEvolutionReport &&
					<div style={{ width: '100%' }}>
						<FlexDiv gap='8px'>
							<BoolCheckbox type='checkbox' checked={chartData.options?.stacked} onClick={() => setChartData({ ...chartData, options: { ...chartData.options, stacked: !chartData.options?.stacked } })} />
							<InputLabel noPadding>{translateToString('dashboard.stacked')}</InputLabel>
						</FlexDiv>
					</div>
				}
			</FlexDiv>
		</TitleAndChild>
	</>;
}

function LegendOptions(props: { representation: string, chartData: ChartData, setChartData: (data: ChartData) => void }) {
	const { representation, chartData, setChartData } = props;
	return <>
		<hr style={{ borderColor: BorderColor, width: '100%', height: '1px', margin: '0 0 -10px 0' }} />
		<TitleAndChild title={translateToString('dashboard.legend_options')}>
			<FlexDiv gap='16px' flow='column' align='stretch' width='100%'>
				<div>
					<FlexDiv gap='8px'>
						<BoolCheckbox type='checkbox' checked={chartData.options?.legend ?? true} onClick={() => setChartData({ ...chartData, options: { ...chartData.options, legend: !chartData.options?.legend } })} />
						<InputLabel noPadding>{translateToString('dashboard.legend')}</InputLabel>
					</FlexDiv>
				</div>
				<div style={{ width: '100%' }}>
					<InputLabel>{translateToString('dashboard.legend_orientation')}</InputLabel>
					<Dropdown
						name='legend_oritentation'
						datalist={CHART_ORIENTATIONS.map(rep => ({ value: rep, label: translateToString(`dashboard.orientations.${rep}`) }))}
						selectedValue={chartData.options?.legend_orientation ? { value: chartData.options.legend_orientation, label: translateToString(`dashboard.orientations.${chartData.options.legend_orientation}`) } : representation === 'pie' ? { value: CHART_ORIENTATIONS[1], label: translateToString('dashboard.orientations.vertical') } : { value: CHART_ORIENTATIONS[0], label: translateToString('dashboard.orientations.horizontal') }}
						searchable={false}
						readOnly
						dropdownStyle={DropdownDashboardCreationStyle}
						onChange={(value) => { if (value) setChartData({ ...chartData, options: { ...chartData.options, legend_orientation: value.value } }); }}
					/>
				</div>
				<div style={{ width: '100%' }}>
					<InputLabel>{translateToString('dashboard.max_items_legend')}</InputLabel>
					<Input
						name='max_legend_items'
						type='number'
						inputStyle={{
							width: '100%',
							containerWidth: '100%',
							padding: '.56rem 0.75rem',
							borderRadius: '5px'
						}}
						value={chartData.options?.max_legend_items}
						onChange={(value: string) => {
							if (value === '') {
								setChartData({ ...chartData, options: { ...chartData.options, max_legend_items: undefined } });
							} else {
								const intValue = parseInt(value);
								if (!isNaN(intValue) && intValue > 0) {
									setChartData({ ...chartData, options: { ...chartData.options, max_legend_items: intValue } });
								}
							}
						}}
					/>
				</div>
			</FlexDiv>
		</TitleAndChild>
	</>;
}

function NumberOptions(props: { representation: string, chartData: ChartData, setChartData: (data: ChartData) => void }) {
	const { representation, chartData, setChartData } = props;
	return <>
		<hr style={{ borderColor: BorderColor, width: '100%', height: '1px', margin: '0 0 -10px 0' }} />
		<TitleAndChild title={translateToString('dashboard.number_options')}>
			<FlexDiv gap='16px' flow='column' align='stretch' width='100%'>
				<div style={{ width: '100%' }}>
					<InputLabel>{translateToString('dashboard.decimal_digits')}</InputLabel>
					<Input
						name='number_extension'
						type='number'
						placeholder='0 = X, 1 = .x, 2 = .xx etc.'
						inputStyle={{
							width: '100%',
							containerWidth: '100%',
							padding: '.56rem 0.75rem',
							borderRadius: '5px'
						}}
						value={chartData.options?.digits_after_decimal}
						onChange={(value: string) => {
							if (value === '') {
								setChartData({ ...chartData, options: { ...chartData.options, digits_after_decimal: undefined } });
							} else {
								const intValue = parseInt(value);
								if (!isNaN(intValue) && intValue >= 0) {
									setChartData({ ...chartData, options: { ...chartData.options, digits_after_decimal: intValue } });
								}
							}
						}}
					/>
				</div>
				<div style={{ width: '100%' }}>
					<InputLabel>{translateToString('dashboard.number_suffix')}</InputLabel>
					<Input
						name='number_extension'
						type='text'
						inputStyle={{
							width: '100%',
							containerWidth: '100%',
							padding: '.56rem 0.75rem',
							borderRadius: '5px'
						}}
						placeholder='%, $, etc.'
						value={chartData.options?.number_extension ?? ''}
						onChange={(value: string) => setChartData({ ...chartData, options: { ...chartData.options, number_extension: value } })}
					/>
				</div>
				{(representation === 'bar' || representation === 'pie') && <div style={{ width: '100%' }}>
					<InputLabel>{translateToString('dashboard.max_number_of_items')}</InputLabel>
					<Input
						name='max_items'
						type='number'
						placeholder={translateToString('dashboard.max_items_placeholder')}
						inputStyle={{
							width: '100%',
							containerWidth: '100%',
							padding: '.56rem 0.75rem',
							borderRadius: '5px'
						}}
						value={chartData.options?.max_values}
						onChange={(value: string) => {
							if (value === '') {
								setChartData({ ...chartData, options: { ...chartData.options, max_values: undefined } });
							} else {
								const intValue = parseInt(value);
								if (!isNaN(intValue) && intValue > 0) {
									setChartData({ ...chartData, options: { ...chartData.options, max_values: intValue } });
								}
							}
						}}
					/>
				</div>}
			</FlexDiv>
		</TitleAndChild>
	</>;
}

function FilterOptions(props: { chartData: ChartData, setChartData: (data: ChartData) => void, computedReport: ComputedReport, state: DashboardState, primaryHeaders: Header[] }) {
	const { chartData, setChartData, computedReport, state, primaryHeaders } = props;
	return <>
		<hr style={{ borderColor: BorderColor, width: '100%', height: '1px', margin: '0 0 -10px 0' }} />
		<TitleAndChild title={translateToString('dashboard.filters')}>
			<FlexDiv gap='16px' flow='column' align='stretch' width='100%'>
				<div style={{ width: '100%' }}>
					<FlexDiv gap='8px'>
						<BoolCheckbox type='checkbox' checked={chartData.footer_values_only} onClick={() => setChartData({ ...chartData, footer_values_only: !chartData.footer_values_only, filters_path: {} })} />
						<InputLabel noPadding>{translateToString('dashboard.total_row_only')}</InputLabel>
					</FlexDiv>
				</div>
				{!chartData.footer_values_only && primaryHeaders.map((header, i) => (
					<div key={`filter_${i}`} style={{ width: '100%' }}>
						<InputLabel>{translateToString('dashboard.filter_for_level')} {valueToString(header.cell.value)}</InputLabel>
						<Dropdown
							name={`filter_level_${i}`}
							datalist={recursiveGetPrimaryCellsForLevel(computedReport.panels[chartData.panel_index].rows, i).map(cell => ({ value: valueToStringWithContext(cell.value, state) ?? '', label: valueToStringWithContext(cell.value, state) ?? '', checked: chartData.filters_path && chartData.filters_path[i] && chartData.filters_path[i].path.includes(valueToStringWithContext(cell.value, state) ?? '') }))}
							dropdownStyle={DropdownDashboardCreationStyle}
							isMulti
							doNotDeleteOptionOnSelect
							checkbox
							checkboxAll
							onChange={(values) => {
								if (values && values.length > 0) {
									const newFilterPath = { ...chartData.filters_path, [i]: { 'path': values.map(v => v.value) } };
									setChartData({ ...chartData, filters_path: newFilterPath });
								} else {
									setChartData({ ...chartData, filters_path: {} });
								}
							}}
						/>
					</div>
				)).filter((_, i) => i <= chartData.group_by_index)}
			</FlexDiv>
		</TitleAndChild>
	</>;
}

function GeneralOptions(props: {
	chartData: ChartData,
	setChartData: (data: ChartData) => void,
	dashboards: Dashboard[],
	chartToEdit?: DashboardChartConfigWithChartData,
	linkToDashboard: string[],
	setLinkToDashboard: (dashboards: string[]) => void,
	MarginInputStyle: InputStyle,
	isEvolutionReport?: boolean,
	maxChartsNb?: number
}) {
	const { chartData, setChartData, linkToDashboard, setLinkToDashboard, MarginInputStyle, isEvolutionReport } = props;
	return <>
		<hr style={{ borderColor: BorderColor, width: '100%', height: '1px', margin: '0 0 -10px 0' }} />
		<TitleAndChild title={translateToString('dashboard.options')}>
			<FlexDiv gap='16px' flow='column' align='stretch' width='100%'>
				{!props.chartToEdit &&
					<div style={{ width: '100%' }}>
						<InputLabel>{translateToString('dashboard.add_to_dashboard')}</InputLabel>
						<Dropdown
							name='add_to_dashboard'
							datalist={props.dashboards.map(dashboard => ({
								value: dashboard.uuid,
								label: dashboard.name,
								checked: linkToDashboard.includes(dashboard.uuid),
								disabled: props.maxChartsNb ? dashboard.charts.length >= props.maxChartsNb : false,
								disabledReason: props.maxChartsNb ? translateToString('dashboard.max_charts_reached', [['MAX_CHARTS_PER_DASHBOARD', props.maxChartsNb.toString()]]) : undefined
							}))}
							dropdownStyle={DropdownDashboardCreationStyle}
							isMulti
							doNotDeleteOptionOnSelect
							checkbox
							onChange={(value) => {
								setLinkToDashboard(value.map(v => v.value));
							}}
						/>
					</div>
				}
				<div style={{ width: '100%' }}>
					<InputLabel>{translateToString('height')}</InputLabel>
					<Dropdown
						name='chart_height'
						datalist={ROW_SPANS.map(span => ({ value: span, label: translateToString(`dashboard.sizes.${ROW_SPAN_LABELS[span]}`) }))}
						selectedValue={{ value: chartData.options?.row_span ?? 1, label: translateToString(`dashboard.sizes.${ROW_SPAN_LABELS[chartData.options?.row_span ?? 1] ?? 'single'}`) }}
						searchable={false}
						readOnly
						dropdownStyle={DropdownDashboardCreationStyle}
						onChange={(value) => { if (value) setChartData({ ...chartData, options: { ...chartData.options, row_span: value.value } }); }}
					/>
				</div>
				<div style={{ width: '100%' }}>
					<InputLabel>{translateToString('width')}</InputLabel>
					<Dropdown
						name='chart_width'
						datalist={[{ value: 1, label: translateToString('dashboard.sizes.single') }, { value: 2, label: translateToString('dashboard.sizes.double') }]}
						selectedValue={chartData.options?.column_span ? { value: chartData.options.column_span, label: chartData.options.column_span === 2 ? translateToString('dashboard.sizes.double') : translateToString('dashboard.sizes.single') } : { value: 1, label: translateToString('dashboard.sizes.single') }}
						searchable={false}
						readOnly
						dropdownStyle={DropdownDashboardCreationStyle}
						onChange={(value) => { if (value) setChartData({ ...chartData, options: { ...chartData.options, column_span: value.value } }); }}
					/>
				</div>
				<div style={{ width: '100%' }}>
					<InputLabel>{translateToString('dashboard.margins')}</InputLabel>
					<div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gridTemplateRows: '60px 60px' }}>
						<FlexDiv gap='4px'>
							<InputLabel noPadding width='4vw'>{translateToString('dashboard.left')}</InputLabel>
							<Input
								name='margin_left'
								type='number'
								placeholder={translateToString('dashboard.in_px')}
								inputStyle={MarginInputStyle}
								value={chartData.options?.margins?.left}
								onChange={(value: string) => {
									if (value === '') {
										setChartData({ ...chartData, options: { ...chartData.options, margins: { ...chartData.options?.margins, left: undefined } } });
									} else {
										const intValue = parseInt(value);
										if (!isNaN(intValue) && intValue >= 0) {
											setChartData({ ...chartData, options: { ...chartData.options, margins: { ...chartData.options?.margins, left: intValue } } });
										}
									}
								}}
							/>
						</FlexDiv>
						<FlexDiv gap='4px'>
							<InputLabel noPadding width='4vw'>{translateToString('dashboard.top')}</InputLabel>
							<Input
								name='margin_top'
								type='number'
								placeholder={translateToString('dashboard.in_px')}
								inputStyle={MarginInputStyle}
								value={chartData.options?.margins?.top}
								onChange={(value: string) => {
									if (value === '') {
										setChartData({ ...chartData, options: { ...chartData.options, margins: { ...chartData.options?.margins, top: undefined } } });
									} else {
										const intValue = parseInt(value);
										if (!isNaN(intValue) && intValue >= 0) {
											setChartData({ ...chartData, options: { ...chartData.options, margins: { ...chartData.options?.margins, top: intValue } } });
										}
									}
								}}
							/>
						</FlexDiv>
						<FlexDiv gap='4px'>
							<InputLabel noPadding width='4vw'>{translateToString('dashboard.right')}</InputLabel>
							<Input
								name='margin_right'
								type='number'
								placeholder={translateToString('dashboard.in_px')}
								inputStyle={MarginInputStyle}
								value={chartData.options?.margins?.right}
								onChange={(value: string) => {
									if (value === '') {
										setChartData({ ...chartData, options: { ...chartData.options, margins: { ...chartData.options?.margins, right: undefined } } });
									} else {
										const intValue = parseInt(value);
										if (!isNaN(intValue) && intValue >= 0) {
											setChartData({ ...chartData, options: { ...chartData.options, margins: { ...chartData.options?.margins, right: intValue } } });
										}
									}
								}}
							/>
						</FlexDiv>
						<FlexDiv gap='4px'>
							<InputLabel noPadding width='4vw'>{translateToString('dashboard.bottom')}</InputLabel>
							<Input
								name='margin_bottom'
								type='number'
								placeholder={translateToString('dashboard.in_px')}
								inputStyle={MarginInputStyle}
								value={chartData.options?.margins?.bottom}
								onChange={(value: string) => {
									if (value === '') {
										setChartData({ ...chartData, options: { ...chartData.options, margins: { ...chartData.options?.margins, bottom: undefined } } });
									} else {
										const intValue = parseInt(value);
										if (!isNaN(intValue) && intValue >= 0) {
											setChartData({ ...chartData, options: { ...chartData.options, margins: { ...chartData.options?.margins, bottom: intValue } } });
										}
									}
								}}
							/>
						</FlexDiv>
					</div>
				</div>
				<div style={{ width: '100%' }}>
					<InputLabel>{translateToString('dashboard.background_color')}</InputLabel>
					<FlexDiv gap='8px'>
						<DropdownColor
							name='chart_background_color'
							dotSize='30px'
							selectedValue={chartData.options?.background_color}
							onChange={(value) => setChartData({ ...chartData, options: { ...chartData.options, background_color: value.value } })}
						/>
						{chartData.options?.background_color && <FlexDiv clickable onClick={() => setChartData({ ...chartData, options: { ...chartData.options, background_color: undefined } })}>
							<Trash2 size={16} color={GreySidely3} />
						</FlexDiv>}
					</FlexDiv>
				</div>
				{isEvolutionReport && <div style={{ width: '100%' }}>
					<InputLabel>{translateToString('granularity')}</InputLabel>
					<Dropdown
						name='chart_granularity'
						datalist={CHART_GRANULARITIES.map(rep => ({ value: rep, label: translateToString(`dashboard.granularities.${rep}`) }))}
						selectedValue={chartData.options?.granularity ? { value: chartData.options.granularity, label: translateToString(`dashboard.granularities.${chartData.options.granularity}`) } : undefined}
						searchable={false}
						readOnly
						dropdownStyle={DropdownDashboardCreationStyle}
						onChange={(value) => { if (value) setChartData({ ...chartData, options: { ...chartData.options, granularity: value.value } }); }}
					/>
				</div>}
			</FlexDiv>
		</TitleAndChild>
	</>;
}

const ROW_SPANS = [0.5, 1, 2, 3];
const ROW_SPAN_LABELS: Record<number, string> = { 0.5: 'half', 1: 'single', 2: 'double', 3: 'triple' };

const MarginInputStyle = {
	width: '15vw',
	containerWidth: '15vw',
	borderRadius: '5px'
};

function AxisOptions(props: { representation: string, chartData: ChartData, setChartData: (data: ChartData) => void }) {
	const { representation, chartData, setChartData } = props;
	if (isSingleValueChart(representation)) return null;
	return <>
		<hr style={{ borderColor: BorderColor, width: '100%', height: '1px', margin: '0 0 -10px 0' }} />
		<TitleAndChild title={translateToString('dashboard.axis_options')}>
			{representation !== 'pie' &&
				<FlexDiv gap='16px' flow='column' align='stretch' width='100%'>
					<div style={{ width: '100%' }}>
						<InputLabel>{translateToString('dashboard.trim_x_labels')}</InputLabel>
						<Input
							name='trim_x_labels'
							type='number'
							inputStyle={{
								width: '100%',
								containerWidth: '100%',
								padding: '.56rem 0.75rem',
								borderRadius: '5px'
							}}
							value={chartData.options?.trim_x_labels ?? ''}
							onChange={(value: string) => {
								if (value === '') {
									setChartData({ ...chartData, options: { ...chartData.options, trim_x_labels: undefined } });
								} else {
									const intValue = parseInt(value);
									if (!isNaN(intValue) && intValue > 0) {
										setChartData({ ...chartData, options: { ...chartData.options, trim_x_labels: intValue } });
									}
								}
							}}
						/>
					</div>
					<div style={{ width: '100%' }}>
						<InputLabel>{translateToString('dashboard.trim_y_labels')}</InputLabel>
						<Input
							name='trim_y_labels'
							type='number'
							inputStyle={{
								width: '100%',
								containerWidth: '100%',
								padding: '.56rem 0.75rem',
								borderRadius: '5px'
							}}
							value={chartData.options?.trim_y_labels ?? ''}
							onChange={(value: string) => {
								if (value === '') {
									setChartData({ ...chartData, options: { ...chartData.options, trim_y_labels: undefined } });
								} else {
									const intValue = parseInt(value);
									if (!isNaN(intValue) && intValue > 0) {
										setChartData({ ...chartData, options: { ...chartData.options, trim_y_labels: intValue } });
									}
								}
							}}
						/>
					</div>
					<div style={{ width: '100%' }}>
						<InputLabel>{translateToString('dashboard.x_axis_legend')}</InputLabel>
						<Input
							name='x_axis_legend'
							type='text'
							inputStyle={{
								width: '100%',
								containerWidth: '100%',
								padding: '.56rem 0.75rem',
								borderRadius: '5px'
							}}
							value={chartData.options?.x_axis_legend ?? ''}
							onChange={(value: string) => setChartData({ ...chartData, options: { ...chartData.options, x_axis_legend: value } })}
						/>
					</div>
					<div style={{ width: '100%' }}>
						<InputLabel>{translateToString('dashboard.y_axis_legend')}</InputLabel>
						<Input
							name='y_axis_legend'
							type='text'
							inputStyle={{
								width: '100%',
								containerWidth: '100%',
								padding: '.56rem 0.75rem',
								borderRadius: '5px'
							}}
							value={chartData.options?.y_axis_legend ?? ''}
							onChange={(value: string) => setChartData({ ...chartData, options: { ...chartData.options, y_axis_legend: value } })}
						/>
					</div>
					<div style={{ width: '100%' }}>
						{representation !== 'line' &&
							<>
								<InputLabel>{translateToString('dashboard.x_axis_boundaries')}</InputLabel>
								<div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gridTemplateRows: '60px' }}>
									<FlexDiv gap='4px'>
										<InputLabel noPadding width='4vw'>min</InputLabel>
										<Input
											name='x_axis_min'
											type='number'
											inputStyle={MarginInputStyle}
											value={chartData.options?.x_axis_boundaries?.min}
											onChange={(value: string) => {
												if (value === '') {
													setChartData({ ...chartData, options: { ...chartData.options, x_axis_boundaries: { ...chartData.options?.x_axis_boundaries, min: undefined } } });
												} else {
													const intValue = parseInt(value);
													if (!isNaN(intValue) && intValue >= 0) {
														setChartData({ ...chartData, options: { ...chartData.options, x_axis_boundaries: { ...chartData.options?.x_axis_boundaries, min: intValue } } });
													}
												}
											}}
										/>
									</FlexDiv>
									<FlexDiv gap='4px'>
										<InputLabel noPadding width='4vw'>max</InputLabel>
										<Input
											name='x_axis_max'
											type='number'
											inputStyle={MarginInputStyle}
											value={chartData.options?.x_axis_boundaries?.max}
											onChange={(value: string) => {
												if (value === '') {
													setChartData({ ...chartData, options: { ...chartData.options, x_axis_boundaries: { ...chartData.options?.x_axis_boundaries, max: undefined } } });
												} else {
													const intValue = parseInt(value);
													if (!isNaN(intValue) && intValue >= 0) {
														setChartData({ ...chartData, options: { ...chartData.options, x_axis_boundaries: { ...chartData.options?.x_axis_boundaries, max: intValue } } });
													}
												}
											}}
										/>
									</FlexDiv>
								</div>
							</>
						}
						<InputLabel>{translateToString('dashboard.y_axis_boundaries')}</InputLabel>
						<div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gridTemplateRows: '60px' }}>
							<FlexDiv gap='4px'>
								<InputLabel noPadding width='4vw'>min</InputLabel>
								<Input
									name='y_axis_min'
									type='number'
									inputStyle={MarginInputStyle}
									value={chartData.options?.y_axis_boundaries?.min}
									onChange={(value: string) => {
										if (value === '') {
											setChartData({ ...chartData, options: { ...chartData.options, y_axis_boundaries: { ...chartData.options?.y_axis_boundaries, min: undefined } } });
										} else {
											const intValue = parseInt(value);
											if (!isNaN(intValue) && intValue >= 0) {
												setChartData({ ...chartData, options: { ...chartData.options, y_axis_boundaries: { ...chartData.options?.y_axis_boundaries, min: intValue } } });
											}
										}
									}}
								/>
							</FlexDiv>
							<FlexDiv gap='4px'>
								<InputLabel noPadding width='4vw'>max</InputLabel>
								<Input
									name='y_axis_max'
									type='number'
									inputStyle={MarginInputStyle}
									value={chartData.options?.y_axis_boundaries?.max}
									onChange={(value: string) => {
										if (value === '') {
											setChartData({ ...chartData, options: { ...chartData.options, y_axis_boundaries: { ...chartData.options?.y_axis_boundaries, max: undefined } } });
										} else {
											const intValue = parseInt(value);
											if (!isNaN(intValue) && intValue >= 0) {
												setChartData({ ...chartData, options: { ...chartData.options, y_axis_boundaries: { ...chartData.options?.y_axis_boundaries, max: intValue } } });
											}
										}
									}}
								/>
							</FlexDiv>
						</div>
					</div>
				</FlexDiv>}
			{representation === 'pie' &&
				<FlexDiv gap='16px' flow='column' align='stretch' width='100%'>
					<div style={{ width: '100%' }}>
						<InputLabel>{translateToString('dashboard.trim_labels')}</InputLabel>
						<Input
							name='trim_x_labels'
							type='number'
							inputStyle={{
								width: '100%',
								containerWidth: '100%',
								padding: '.56rem 0.75rem',
								borderRadius: '5px'
							}}
							value={chartData.options?.trim_x_labels ?? ''}
							onChange={(value: string) => {
								if (value === '') {
									setChartData({ ...chartData, options: { ...chartData.options, trim_x_labels: undefined } });
								} else {
									const intValue = parseInt(value);
									if (!isNaN(intValue) && intValue > 0) {
										setChartData({ ...chartData, options: { ...chartData.options, trim_x_labels: intValue } });
									}
								}
							}}
						/>
					</div>
				</FlexDiv>}
		</TitleAndChild>
	</>;
}

export function CreateChartPopup(props: {
	dashboards: Dashboard[],
	onClose: () => void,
	onSubmit: () => void,
	computedReport?: ComputedReport & { name: string, report_id: number },
	chartToEdit?: DashboardChartConfigWithChartData,
	linkedDashboard?: string,
	maxChartsNb?: number,
	filterDates?: OnDateChangeType,
	chartType?: ChartRepresentation
}): JSX.Element {
	const [chartName, setChartName] = React.useState<string>(props.chartToEdit?.name ?? '');
	const [linkedReportId, setLinkedReportId] = React.useState<number | null>(props.computedReport ? props.computedReport.report_id : props.chartToEdit ? props.chartToEdit.report_id : null);
	const [linkedReportFront, setLinkedReportFront] = React.useState<Report | null>(null);
	const [reports, setReports] = React.useState<Report[]>([]);
	const [loadReport, setLoadReport] = React.useState<boolean>(props.chartToEdit ? true : false);
	const [reportLoadingState, setReportLoadingState] = React.useState<LoadingStateEnum>(LoadingStateEnum.LOADED);
	const [computedReport, setComputedReport] = React.useState<ComputedReport | null>(props.computedReport ?? null);
	const [representation, setRepresentation] = React.useState<ChartRepresentation>(props.chartToEdit ? props.chartToEdit.representation : props.chartType ?? 'bar');
	const [linkToDashboard, setLinkToDashboard] = React.useState<string[]>(props.linkedDashboard ? [props.linkedDashboard] : []);
	const [generatePreview, setGeneratePreview] = React.useState<boolean>(false);
	const [previewSvg, setPreviewSvg] = React.useState<SVGSVGElement | HTMLDivElement | null>(null);
	const [previewCleanup, setPreviewCleanup] = React.useState<(() => void) | null>(null);
	const previewContainerParentRef = React.useRef<HTMLDivElement>(null);
	const previewContainerRef = React.useRef<HTMLDivElement>(null);
	const DEFAULT_CHART_DATA: ChartData = { panel_index: 0, values_index: 0, group_by_index: 0 };
	const [chartData, setChartData] = React.useState<ChartData>(DEFAULT_CHART_DATA);
	const [chartToEditLoaded, setChartToEditLoaded] = React.useState<boolean>(false);
	const skipNextRepresentationEffectRef = React.useRef<boolean>(false);
	const primaryHeaders = computedReport ? computedReport.panels[chartData.panel_index].headers.filter(header => header.primary) : [];
	const nonPrimaryHeaders = computedReport ? computedReport.panels[chartData.panel_index].headers.filter(header => !header.primary) : [];
	const isEvolutionReport = linkedReportFront ? 'evolution' in linkedReportFront.value : false;
	const [goalTree, setGoalTree] = React.useState<GoalTree>();
	const users = useRecoilValue(AUsers);
	const products = useRecoilValue(AProducts);
	const companies = useRecoilValue(ACompanies);
	const campaigns = useRecoilValue(ACampaigns);
	const nonPrimaryHeadersDataList = nonPrimaryHeaders.reduce((acc: DropdownData[], header, i) => {
		const valueString = valueToString(header.cell.value);
		if (valueString) acc.push({ value: i, label: valueString });
		return acc;
	}, []);
	const columnsDataList = isEvolutionReport || representation === 'bar' ? [{ value: undefined, label: translateToString('dashboard.no_column') }, ...nonPrimaryHeadersDataList] : nonPrimaryHeadersDataList;
	const isStatic = isStaticChart(representation);
	const hasStaticContent = representation === 'text' ? !!chartData.options?.text?.trim() : !!chartData.options?.image;

	const history = useHistory();
	const query = new URLSearchParams(history.location.search);
	const cookies = new Cookies();

	const state: DashboardState = {
		dashboard: null,
		foundationUrl: URL_FOUNDATION,
		authToken: query.get('token') ?? (cookies.get('id_token') as string | undefined)?.split(' ')[1] ?? '',
		users: new Map(users.map(user => [user.id, user.name])),
		products: new Map(products.map(product => [product.uuid, product.name])),
		companies: new Map(Object.entries(companies).map(([key, value]) => [parseInt(key), value])),
		campaigns: new Map(Object.entries(campaigns).map(([key, value]) => [parseInt(key), value.name])),
		rawProducts: products,
		filterDates: props.filterDates
	};

	React.useEffect(() => {
		getReports().then(r => setReports(r));
	}, []);

	React.useEffect(() => {
		if (props.chartToEdit) {
			setChartName(props.chartToEdit?.name ?? '');
			setLinkedReportId(props.chartToEdit.report_id);
			setRepresentation(props.chartToEdit.representation);
			setChartData(props.chartToEdit.data);
			setChartToEditLoaded(false);
			skipNextRepresentationEffectRef.current = true;
		}
	}, [props.chartToEdit]);

	React.useEffect(() => {
		if (skipNextRepresentationEffectRef.current) {
			skipNextRepresentationEffectRef.current = false;
			return;
		}

		let chartData = DEFAULT_CHART_DATA;
		switch (representation) {
			case 'bar':
				chartData = { ...DEFAULT_CHART_DATA, options: { orientation: 'horizontal', sort: 'desc' } };
				break;
			case 'line':
				chartData = { panel_index: 0, group_by_index: 0, options: { legend: true, color_gradient: true } };
				break;
		}
		setChartData(chartData);
	}, [representation, linkedReportId]);

	const chart: DashboardChartConfigWithChartData | undefined = linkedReportId || isStatic ? {
		uuid: '',
		report_id: linkedReportId,
		data: chartData,
		sequence: 0,
		representation,
		name: chartName,
	} : undefined;

	React.useEffect(() => {
		setTimeout(() => {
			setGeneratePreview(true);
		}, 500);
	}, []);

	React.useEffect(() => {
		if (linkedReportId) {
			getReportById(linkedReportId).then(setLinkedReportFront);
		}
		setComputedReport(props.computedReport ?? null);
		setLoadReport(false);
	}, [linkedReportId]);

	React.useEffect(() => {
		if (computedReport && linkedReportFront && chart && chart.data.goals) {
			getGoalsAndGenerateTree(chart, linkedReportFront, computedReport, state).then(setGoalTree);
		}
	}, [computedReport, linkedReportFront, chart?.data.goals]);

	React.useEffect(() => {
		if ((loadReport || (props.chartToEdit && !chartToEditLoaded)) && linkedReportFront && !props.computedReport) {
			setReportLoadingState(LoadingStateEnum.LOADING);
			try {
				getReport({
					companyId: undefined,
					userId: undefined,
					filterDates: props.filterDates,
					products: products,
					report: linkedReportFront
				}).then((result) => {
					setComputedReport(result.report);
					setReportLoadingState(LoadingStateEnum.LOADED);
					setChartToEditLoaded(true);
				});
			} catch (e) {
				setReportLoadingState(LoadingStateEnum.ERROR);
				console.error('Error loading report for chart creation/editing', e);
				return;
			}
		}
	}, [loadReport, linkedReportFront, chartToEditLoaded]);

	React.useEffect(() => {
		if (generatePreview && linkedReportId && computedReport && previewContainerParentRef.current && chart) {
			if (previewCleanup) {
				previewCleanup();
				setPreviewCleanup(null);
			}
			const svg = generateChartSvg({
				report: computedReport,
				chart,
				state,
				width: previewContainerParentRef.current?.clientWidth ?? 400,
				height: undefined,
				goalTree,
				setData: undefined,
				onNavigateInData: undefined,
				filterPath: []
			});
			if (svg) {
				setPreviewSvg(svg.element);
				if (svg.cleanup) {
					(svg.element as ElementWithCleanup)._cleanupTooltip = svg.cleanup;
					setPreviewCleanup(() => svg.cleanup!);
				}
			} else {
				setPreviewSvg(null);
			}
			setGeneratePreview(false);
		}
	}, [generatePreview, computedReport, previewContainerParentRef.current]);

	React.useEffect(() => {
		if (!isStatic || !chart) return;
		setPreviewSvg(createStaticWidget(chart, CHART_HEIGHT * (chartData.options?.row_span ?? 1)));
	}, [representation, chartData]);

	React.useEffect(() => {
		if (previewSvg && previewContainerRef.current) {
			previewContainerRef.current.innerHTML = '';
			previewContainerRef.current.appendChild(previewSvg);
		}
		// Cleanup function when component unmounts or preview changes
		return () => {
			if (previewCleanup) {
				previewCleanup();
			}
		};
	}, [previewSvg]);

	return <PopupCreation title={props.chartToEdit ? translateToString('dashboard.edit_chart') : translateToString('dashboard.create_chart')}
		messageButton={props.chartToEdit ? translateToString('save') : translateToString('create')}
		content={
			<FlexDiv height='100%'>
				<DashboardCreateContainer centered margin='0 8px'>
					<div style={{ width: '100%' }}>
						<InputLabel required>{translateToString('dashboard.name')}</InputLabel>
						<Input
							name='dashboard_name'
							type='text'
							inputStyle={{
								width: '100%',
								containerWidth: '100%',
								padding: '.56rem 0.75rem',
								borderRadius: '5px'
							}}
							placeholder={translateToString('dashboard.chart_name_placeholder')}
							value={chartName}
							onChange={(value) => setChartName(value as string)}
						/>
					</div>
					<div style={{ width: '100%' }}>
						<InputLabel required>{translateToString('dashboard.representation')}</InputLabel>
						<Dropdown
							name='chart_representation'
							datalist={CHART_REPRESENTATIONS.map(rep => ({ value: rep, label: translateToString(`dashboard.representations.${rep}`) }))}
							selectedValue={representation ? { value: representation, label: translateToString(`dashboard.representations.${representation}`) } : undefined}
							searchable={false}
							readOnly
							dropdownStyle={DropdownDashboardCreationStyle}
							onChange={(value) => { if (value) setRepresentation(value.value); }}
						/>
					</div>
					<StaticWidgetOptions representation={representation} chartData={chartData} setChartData={setChartData} />
					{!isStatic && <div style={{ width: '100%' }}>
						<InputLabel required>{translateToString('dashboard.linked_report')}</InputLabel>
						{props.chartToEdit || props.computedReport ?
							<Input
								name='linked_report'
								type='text'
								inputStyle={{
									width: '100%',
									containerWidth: '100%',
									padding: '.56rem 0.75rem',
									borderRadius: '5px'
								}}
								disabled
								value={linkedReportFront?.name ?? ''}
							/>
							:
							<Dropdown
								name='linked_charts'
								datalist={reports.map(report => ({ value: report.id, label: report.name })).sort((a, b) => a.label.localeCompare(b.label))}
								searchable
								dropdownStyle={DropdownDashboardCreationStyle}
								onChange={(value) => {
									if (value) {
										setLinkedReportId(value.value);
									}
								}}
							/>
						}
					</div>}
					{linkedReportFront && loadReport == false && !props.chartToEdit && !props.computedReport && <div style={{ alignSelf: 'center' }}>
						<DefaultButton width='20vw' onClick={() => setLoadReport(true)}>{translateToString('dashboard.load_report_infos')}</DefaultButton>
					</div>}
					{reportLoadingState === LoadingStateEnum.LOADING && <div style={{ width: '40px' }}><Loader width='40px' /></div>}
					{computedReport && computedReport.panels.length > 1 && <div style={{ width: '100%' }}>
						<InputLabel required>{translateToString('dashboard.panel')}</InputLabel>
						<Dropdown
							name='report_panel'
							datalist={computedReport.panels.reduce((acc: DropdownData[], panel, i) => {
								const valueString = valueToString(panel.value);
								if (valueString) acc.push({ value: i, label: valueString });
								return acc;
							}, [])}
							searchable={false}
							readOnly
							dropdownStyle={DropdownDashboardCreationStyle}
							onChange={(value) => {
								if (value)
									setChartData({ ...chartData, panel_index: value.value });
							}}
							selectedValue={chartData.panel_index !== undefined ? { value: chartData.panel_index, label: valueToString(computedReport.panels[chartData.panel_index].value) ?? '' } : undefined}
						/>
					</div>}
					{computedReport && representation !== 'line' &&
						<div style={{ width: '100%' }}>
							<InputLabel required>{translateToString('dashboard.column')}</InputLabel>
							<Dropdown
								name='report_column'
								datalist={columnsDataList}
								searchable={false}
								readOnly
								dropdownStyle={DropdownDashboardCreationStyle}
								onChange={(value) => {
									if (value && value.value != null)
										setChartData({ ...chartData, values_index: value.value });
									else
										setChartData({ ...chartData, values_index: undefined });
								}}
								selectedValue={chartData.values_index !== undefined ? { value: chartData.values_index, label: valueToString(nonPrimaryHeaders[chartData.values_index].cell.value) ?? '' } : { value: undefined, label: translateToString('dashboard.no_column') }}
							/>
						</div>
					}
					{
						computedReport && <>
							<div style={{ width: '100%' }}>
								<InputLabel required>{translateToString('dashboard.row_level')}</InputLabel>
								<Dropdown
									name='report_column'
									datalist={primaryHeaders.reduce((acc: DropdownData[], header, i) => {
										const valueString = valueToString(header.cell.value);
										if (valueString) acc.push({ value: i, label: valueString });
										return acc;
									}, [])}
									searchable={false}
									readOnly
									dropdownStyle={DropdownDashboardCreationStyle}
									onChange={(value) => {
										if (value)
											setChartData({ ...chartData, group_by_index: value.value });
									}}
									selectedValue={chartData.group_by_index !== undefined ? { value: chartData.group_by_index, label: valueToString(primaryHeaders[chartData.group_by_index].cell.value) ?? '' } : undefined}
								/>
							</div>
							{representation === 'bar' &&
								<div style={{ width: '100%' }}>
									<FlexDiv gap='8px'>
										<BoolCheckbox type='checkbox' checked={chartData.goals} onClick={() => setChartData({ ...chartData, goals: !chartData.goals })} />
										<InputLabel noPadding>{translateToString('dashboard.use_goals')}</InputLabel>
									</FlexDiv>
								</div>
							}
							<FlexDiv width='100%' gap='16px' flow='column' align='stretch'>
								<FilterOptions chartData={chartData} setChartData={setChartData} computedReport={computedReport} state={state} primaryHeaders={primaryHeaders} />
							</FlexDiv>
						</>
					}
					<div style={{ width: '100%' }}>
						<FlexDiv gap='16px' flow='column' align='stretch'>
							<GeneralOptions
								chartData={chartData}
								setChartData={setChartData}
								dashboards={props.dashboards}
								chartToEdit={props.chartToEdit}
								linkToDashboard={linkToDashboard}
								setLinkToDashboard={setLinkToDashboard}
								MarginInputStyle={MarginInputStyle}
								isEvolutionReport={isEvolutionReport}
								maxChartsNb={props.maxChartsNb}
							/>
							{representation === 'line' &&
								<LineOnlyOptions representation={representation} chartData={chartData} setChartData={setChartData} />
							}
							{representation === 'pie' &&
								<PieOnlyOptions representation={representation} chartData={chartData} setChartData={setChartData} />
							}
							{representation === 'bar' &&
								<BarOnlyOptions representation={representation} chartData={chartData} setChartData={setChartData} isEvolutionReport={isEvolutionReport} />
							}
							{representation === 'number' && isEvolutionReport &&
								<NumberOnlyOptions representation={representation} chartData={chartData} setChartData={setChartData} />
							}
							{representation === 'gauge' &&
								<GaugeOnlyOptions chartData={chartData} setChartData={setChartData} MarginInputStyle={MarginInputStyle} />
							}
							{!isStatic && <>
								<NumberOptions representation={representation} chartData={chartData} setChartData={setChartData} />
								<AxisOptions representation={representation} chartData={chartData} setChartData={setChartData} />
								<LegendOptions representation={representation} chartData={chartData} setChartData={setChartData} />
							</>}
						</FlexDiv>
					</div>
					{!isStatic && <Restricted to={{ objectAction: 'CreateAi' }}>
						<DashboardSidelyAiCreation
							value={chartData?.ai_options?.instructions}
							onChange={(instructions) => setChartData({ ...chartData, ai_options: { ...chartData.ai_options, instructions } })}
						/>
					</Restricted>}
				</DashboardCreateContainer>
				<DashboardCreateContainer margin='0 8px'>
					<PreviewTitle>{translateToString('dashboard.preview')}</PreviewTitle>
					<div ref={previewContainerParentRef}
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							width: '100%',
							height: '100%',
							border: `1px solid ${BorderColor}`,
							borderRadius: '5px',
							padding: '12px',
							backgroundColor: chartData.options?.background_color ? chartBackgroundColor(chartData.options.background_color) : undefined,
						}}>
						{previewSvg ? <FlexDiv flow='column' align='stretch' width={isStatic ? '100%' : undefined} height={isStatic ? '100%' : undefined}>
							{!isStatic && <div style={{ fontWeight: 600, fontSize: 14, marginBottom: '-20px', paddingLeft: '10px' }}>{chartName}</div>}
							<div ref={previewContainerRef} style={isStatic ? { width: '100%', height: '100%' } : undefined} />
						</FlexDiv>
							:
							<ChartColumn strokeWidth={2.5} color={GreySidely3} size={50} />}
					</div>
					{!isStatic && <FlexDiv justify='center' width='100%'><DefaultButton disabled={!computedReport} width='15vw' onClick={() => setGeneratePreview(true)}>{translateToString('dashboard.generate_preview')}</DefaultButton></FlexDiv>}
				</DashboardCreateContainer>
			</FlexDiv>
		}
		canValidate={chartName.trim().length > 0 && (isStatic ? hasStaticContent : linkedReportId !== null)}
		onSubmit={
			props.chartToEdit ? () => {
				if (!props.chartToEdit) return;
				putChart(props.chartToEdit.uuid, {
					report_id: isStatic ? null : linkedReportId!,
					data: chartData,
					representation,
					name: chartName,
				}).then(() => {
					setLinkedReportId(null);
					setComputedReport(null);
					setLoadReport(false);
					setChartName('');
					props.onClose();
					props.onSubmit();
				});
			} :
				() => postChart({
					report_id: isStatic ? null : linkedReportId!,
					data: chartData,
					representation,
					name: chartName,
					linked_dashboards: linkToDashboard,
				}).then(() => {
					setLinkedReportId(null);
					setComputedReport(null);
					setLoadReport(false);
					setChartName('');
					props.onClose();
					props.onSubmit();
				})}
		onClose={props.onClose}
	/>;
}

function MaximiseChartPopup(props: { props: GenerateChartSvgProps, onClose: () => void }) {
	const [previewSvg, setPreviewSvg] = React.useState<SVGSVGElement | HTMLDivElement | null>(null);
	const [breadCrumbSvg, setBreadCrumbSvg] = React.useState<HTMLDivElement | null>(null);
	const [previewCleanup, setPreviewCleanup] = React.useState<(() => void) | null>(null);
	const [isLoading, setIsLoading] = React.useState<boolean>(true);
	const previewContainerRef = React.useRef<HTMLDivElement>(null);
	const previewBreadCrumbRef = React.useRef<HTMLDivElement>(null);
	const previewContainerParentRef = React.useRef<HTMLDivElement>(null);

	React.useEffect(() => {
		if (previewContainerParentRef.current) {
			// Clean up previous preview
			if (previewCleanup) {
				previewCleanup();
				setPreviewCleanup(null);
			}

			const result = generateChartSvg({
				...props.props,
				width: props.props.chart.representation === 'pie' ? previewContainerParentRef.current?.clientWidth - 100 : previewContainerParentRef.current?.clientWidth ?? 200,
				height: props.props.chart.representation === 'pie' ? previewContainerParentRef.current?.clientHeight - 140 : (previewContainerParentRef.current?.clientHeight ?? 400) - 40,
				onNavigateInData: (svg, breadCrumb) => {
					setBreadCrumbSvg(breadCrumb);
					setPreviewSvg(svg);
					setIsLoading(false);
				}
			});
			if (result) {
				setPreviewSvg(result.element);
				if (result.cleanup) {
					(result.element as ElementWithCleanup)._cleanupTooltip = result.cleanup;
					setPreviewCleanup(() => result.cleanup!);
				}
			} else {
				setPreviewSvg(null);
			}
			setIsLoading(false);
		}
	}, [props.props, previewContainerParentRef.current]);

	React.useEffect(() => {
		if (previewBreadCrumbRef.current) {
			previewBreadCrumbRef.current.innerHTML = '';
			if (breadCrumbSvg) previewBreadCrumbRef.current.appendChild(breadCrumbSvg);
		}
	}, [breadCrumbSvg]);

	React.useEffect(() => {
		if (previewSvg && previewContainerRef.current) {
			previewContainerRef.current.innerHTML = '';
			previewContainerRef.current.appendChild(previewSvg);
		}
		// Cleanup function when component unmounts or preview changes
		return () => {
			if (previewCleanup) {
				previewCleanup();
			}
		};
	}, [previewSvg]);

	return <div ref={previewContainerParentRef}
		style={{
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			width: '100%',
			height: '100%',
			border: `1px solid ${BorderColor}`,
			borderRadius: '5px',
			padding: '12px',
		}}>
		{!isLoading && previewSvg ? <FlexDiv flow='column' align='stretch'>
			<FlexDiv gap='8px' padding='0 0 0 10px'>
				<div style={{ fontWeight: 600, fontSize: 14 }}>{props.props.chart.name ?? ''}</div>
				{previewSvg instanceof SVGSVGElement && <FlexDiv
					clickable
					title={translateToString('dashboard.export_chart')}
					style={{ opacity: 0.7 }}
					onClick={() => exportChartAsPng(previewSvg, props.props.chart.name).catch(() => launchToastError(translateToString('dashboard.errors.export_failed')))}
				>
					<Download size={16} color={SidelyBlack} />
				</FlexDiv>}
			</FlexDiv>
			<div style={{ height: '20px', paddingLeft: '10px' }} ref={previewBreadCrumbRef} />
			<div ref={previewContainerRef} />
		</FlexDiv>
			:
			<Loader width='50px' />}
	</div>;
}

export default function Dashboards(props: ComponentProps & { companyId?: number, isMobile?: boolean }) {
	const [popupOpen, setPopupOpen] = React.useState<'chart' | 'dashboard' | 'manage_charts' | 'manage_dashboards' | null>(null);
	const [restrictionModalState, setRestrictionModalState] = React.useState<MandatoryModalState<string>>({ isOpen: false });
	const [maximiseChartPopupOpen, setMaximiseChartPopupOpen] = React.useState<{ props: GenerateChartSvgProps }>();
	const [uuidToEdit, setUuidToEdit] = React.useState<string | null>(null);
	const [refreshMobileDashboard, setRefreshMobileDashboard] = React.useState<boolean>(false);
	const [refreshing, setRefreshing] = React.useState<boolean>(false);
	const [dashboards, setDashboards] = React.useState<Dashboard[]>([]);
	const [charts, setCharts] = React.useState<DashboardChartConfigWithChartData[]>([]);
	const panelContext = React.useContext(PanelContext);
	const [chartData, setChartData] = React.useState<Map<string,(ValueNameData | GroupedValueNameData[])[]>>(new Map());
	const [selectedDashboard, setSelectedDashboard] = React.useState<Dashboard>();
	const [linkedDashboard, setLinkedDashboard] = React.useState<string | undefined>(undefined);
	const [filterDates, setFilterDates] = React.useState<OnDateChangeType>({ startDate: null, endDate: null });
	const [securityGroups, setSecurityGroups] = React.useState<Group[]>([]);
	const [dashboardTypeToOpen, setDashboardTypeToOpen] = React.useState<'company' | 'dashboard' | undefined>(props.companyId ? 'company' : undefined);
	const [chartType, setChartType] = React.useState<ChartRepresentation | undefined>(undefined);
	const userFilterHook = React.useState<number | null>(null);
	const [userFilter, setUserFilter] = userFilterHook;
	const amISuperAdmin = isSuperAdmin();
	const maxDashboardsNb = undefined; // before it was 3
	const maxChartsNb = amISuperAdmin ? undefined : 10;
	const { alert } = React.useContext(AlertContext);
	const permissionContext = React.useContext(PermissionContext);
	const canReadAi = permissionContext.isAllowedTo({ objectAction: 'ReadAi' });
	const canCreateDashboard = !props.isMobile && permissionContext.isAllowedTo({ objectAction: 'CreateDashboard' });
	const canEditDashboard = !props.isMobile && permissionContext.isAllowedTo({ objectAction: 'UpdateDashboard' });
	const canDeleteDashboard = !props.isMobile && permissionContext.isAllowedTo({ objectAction: 'DeleteDashboard' });

	const dropdownData: DropdownData<string>[] = [
		{ value: 'create_chart', label: translateToString('dashboard.create_chart') },
		{ value: 'manage_dashboards', label: translateToString('dashboard.manage_dashboards') },
		{ value: 'manage_charts', label: translateToString('dashboard.manage_charts') },
	];

	const onDatesChange = ({ startDate, endDate }: OnDateChangeType) => {
		startDate?.startOf('day');
		endDate?.endOf('day');
		setFilterDates({ startDate, endDate });
	};

	// Remove Ai panel when leaving the dashboard
	React.useEffect(() => {
		getGroups().then((res) => setSecurityGroups(res.data));
		return () => { panelContext.setPanel('calendar'); };
	}, []);

	React.useEffect(() => {
		props.setToolBarState({
			title: translateToString('dashboard.title'),
			bottomLeftToolbarComponent: <FlexDiv gap='8px' padding='0 0 0 5px'>
				{securityGroups.length > 0 && <ToolbarFilter
					category={AtomCategory.DASHBOARD}
					elements={[{
						kind: ToolbarElement.USER_FILTER,
						allIsNone: true,
						hook: userFilterHook,
						noMeOption: true,
					}]}
				/>
				}
				<RawDatePicker
					onDatesChange={onDatesChange}
					start={filterDates.startDate}
					end={filterDates.endDate}
					future
				/>
				<RefreshButton
					isLoading={refreshing}
					onFilter={() => {
						setRefreshMobileDashboard(!refreshMobileDashboard);
					}}
				/>
				{(!!userFilter || (!!filterDates.startDate && !!filterDates.endDate)) && <ToolbarFilterButton
					title={translateToString('reset_filters')}
					isActive={true}
					icon={<Undo2 color={PrimaryColor} />}
					onClick={() => {
						setUserFilter(null);
						setFilterDates({ startDate: null, endDate: null });
					}}
				/>
				}
			</FlexDiv>,
			bottomRightToolbarComponent: <>
				{charts.length > 0 && <Restricted to={{ objectAction: 'ReadAi' }}>
					<AiButton disabled={chartData.size === 0} innerStyle={{ margin: '0 5px 0 0' }} onClick={() => {
						const key = 'Dashboards';
						const [__, setAiState] = panelContext.aiStateHook;
						const [____, setTitle] = panelContext.titleHook;
						setAiState({
							archives: [dashboardToAiArchive(selectedDashboard, chartData)],
							suggestions: [],
							conversationId: key,
							chartId: undefined,
							dashboardId: selectedDashboard?.uuid,
							filters: toAiDataFilters(props.companyId, userFilter ?? undefined, filterDates),
							lastTimeRefreshed: Date.now(),
						});
						panelContext.setIsPanelOpen(true);
						panelContext.setPanel('ai');
						setTitle(selectedDashboard?.name);
					}}>
						<Translate id='ask_sidely_ai' />
					</AiButton>
				</Restricted>}
				{canCreateDashboard &&
					<Dropdown
						searchable={false}
						dropdownStyle={{ optionLeft: '-115px', optionWidth: '160px', optionHeight: '200px' }}
						datalist={dropdownData}
						name='create_dashboard'
						JSXButton={() => <ToolbarImageContainer hasPointer><Ellipsis size={18} strokeWidth={2.5} color={GreySidely3} /></ToolbarImageContainer>}
						onChange={(value: DropdownData<string>) => {
							switch (value.value) {
								case 'create_chart':
									setPopupOpen('chart');
									break;
								case 'manage_dashboards':
									setPopupOpen('manage_dashboards');
									break;
								case 'manage_charts':
									setPopupOpen('manage_charts');
									break;
							}
						}}
					/>
				}
			</>
		});
	}, [chartData, selectedDashboard, filterDates, userFilter, securityGroups, refreshing]);

	React.useEffect(() => {
		setRefreshing(true);
		try {
			getDashboardsWeb().then(dashboards => {
				setDashboards(dashboards);
				getCharts().then(charts => {
					setCharts(charts);
				});
				setRefreshing(false);
			});
		} catch (_e) {
			setRefreshing(false);
		}
	}, [refreshMobileDashboard]);

	function resetPopupState() {
		setPopupOpen(null);
		setUuidToEdit(null);
		setLinkedDashboard(undefined);
		setDashboardTypeToOpen(undefined);
		setSelectedDashboard(undefined);
	}

	const innerDashboard = <InnerDashboard
		isMobile={props.isMobile}
		companyId={props.companyId}
		userId={userFilter ?? undefined}
		filterDates={filterDates.startDate && filterDates.endDate ? { startDate: filterDates.startDate, endDate: filterDates.endDate } : undefined}
		refresh={refreshMobileDashboard}
		maxDashboardsNb={maxDashboardsNb}
		maxCharts={maxChartsNb}
		onCreateDashboard={canCreateDashboard ? () => { setDashboardTypeToOpen('dashboard'); setPopupOpen('dashboard'); } : undefined}
		onCreateChart={canCreateDashboard && (maxChartsNb ? charts.length < maxChartsNb : true) ? (dashboardUuid) => { setLinkedDashboard(dashboardUuid); setPopupOpen('chart'); } : undefined}
		onEditDashboard={canEditDashboard ? (uuid) => { setUuidToEdit(uuid); setPopupOpen('dashboard'); } : undefined}
		onDeleteDashboard={canDeleteDashboard ? (uuid) => {
			alert({
				title: translateToString('dashboard.delete_dashboard'),
				content: translateToString('dashboard.confirm_delete_dashboard'),
				buttons: [{ title: translateToString('delete'), res: AlertRes.Ok, style: ButtonStyle.Error }],
				zIndex: 1200
			}).then(res => {
				if (res.res === AlertRes.Ok) {
					deleteDashboard(uuid).then(() => {
						setRefreshMobileDashboard(!refreshMobileDashboard);
					});
				}
			});
		} : undefined}
		onEditChart={canEditDashboard ? (uuid) => { setUuidToEdit(uuid); setPopupOpen('chart'); } : undefined}
		onSeeReport={props.isMobile ? undefined : (id) => { localStorage.setItem('report_id_to_view', id.toString()); window.open('/reports#generic'); }}
		onChartDataLoad={(uuid, data) => setChartData((chartData) => {
			const newData = new Map(chartData);
			newData.set(uuid, data);
			return newData;
		})}
		onDashboardChange={setSelectedDashboard}
		onAiChat={canReadAi ? (chart, data) => {
			const [_, setTitle] = panelContext.titleHook;
			const [__, setAiState] = panelContext.aiStateHook;

			setAiState({
				archives: [chartToAiArchive(chart, data)],
				suggestions: [],
				conversationId: chart.uuid,
				chartId: chart.uuid,
				dashboardId: undefined,
				filters: toAiDataFilters(props.companyId, userFilter ?? undefined, filterDates),
				lastTimeRefreshed: Date.now(),
			});
			panelContext.setPanel('ai');
			panelContext.setIsPanelOpen(true);
			setTitle(chart.name);
		} : undefined}
		onRemoveChart={canEditDashboard ? (dashboardUuid, chartUuid) => {
			const dashboard = dashboards.find(d => d.uuid === dashboardUuid);
			if (!dashboard) return;
			putDashboard(dashboardUuid, {
				...dashboard,
				charts: dashboard.charts.reduce((acc: DashboardChartConfig[], chart: DashboardChartConfigWithChartData) => {
					if (chart.uuid !== chartUuid) acc.push({ uuid: chart.uuid, sequence: chart.sequence });
					return acc;
				}, [] as DashboardChartConfig[])
			}).then(() => {
				setRefreshMobileDashboard(!refreshMobileDashboard);
			});
		} : undefined}
		onDuplicateChart={canCreateDashboard ? (dashboardUuid, chartUuid) => {
			const chartDataToDuplicate = charts.find(c => c.uuid === chartUuid);
			if (!chartDataToDuplicate) return;
			postChart({ ...chartDataToDuplicate, name: `${chartDataToDuplicate.name} (${translateToString('dashboard.copy')})`, linked_dashboards: [dashboardUuid] }).then(() => {
				setRefreshMobileDashboard(!refreshMobileDashboard);
			});
		} : undefined}
		onOpenFullscreen={props.isMobile ? undefined : (props) => {
			setMaximiseChartPopupOpen({ props });
		}}
		onAddRestrictions={canCreateDashboard ? (uuid) => setRestrictionModalState({ isOpen: true, data: uuid }) : undefined}
	/>;

	if (props.isMobile) return <MobileContainer>{innerDashboard}</MobileContainer>;

	return <Container>
		<Popup
			isOpen={!!popupOpen}
			popupMode={popupOpen === 'chart' || popupOpen === 'dashboard' ? PopupMode.Default : PopupMode.Details}
			onClickOut={() => resetPopupState()}
		>
			{popupOpen === 'dashboard' &&
				<CreateDashboardPopup
					dashboardType={dashboardTypeToOpen}
					maxDashboardsNb={maxDashboardsNb}
					maxChartsNb={maxChartsNb}
					dashboards={dashboards}
					onClose={() => {
						resetPopupState();
					}}
					onSubmit={() => {
						setRefreshMobileDashboard(!refreshMobileDashboard);
						resetPopupState();
					}}
					dashboardToEdit={dashboards.find(d => d.uuid === uuidToEdit) ?? undefined}
				/>}
			{popupOpen === 'chart' &&
				<CreateChartPopup
					dashboards={dashboards}
					onClose={() => {
						resetPopupState();
					}}
					onSubmit={() => {
						setRefreshMobileDashboard(!refreshMobileDashboard);
						resetPopupState();
					}}
					chartToEdit={charts.find(c => c.uuid === uuidToEdit) ?? undefined}
					linkedDashboard={linkedDashboard}
					maxChartsNb={maxChartsNb}
					filterDates={filterDates}
					chartType={chartType}
				/>}
			{popupOpen === 'manage_dashboards' &&
				<ManageDashboardsPopup
					dashboards={dashboards}
					onClose={() => { setPopupOpen(null); }}
					onSubmit={() => setRefreshMobileDashboard(!refreshMobileDashboard)}
					onEditDashboard={(uuid) => { setUuidToEdit(uuid); setPopupOpen('dashboard'); }}
					setPopupOpen={setPopupOpen}
					setDashboardTypeToOpen={setDashboardTypeToOpen}
					maxDashboardsNb={maxDashboardsNb}
				/>}
			{popupOpen === 'manage_charts' &&
				<ManageChartsPopup
					onClose={() => { setPopupOpen(null); }}
					onSubmit={() => { }}
					onEditChart={(uuid) => { setUuidToEdit(uuid); setPopupOpen('chart'); }}
					onCreateChart={(chartType) => { setChartType(chartType); setPopupOpen('chart'); }}
					onDuplicateChart={(chartUuid) => {
						const chartDataToDuplicate = charts.find(c => c.uuid === chartUuid);
						if (!chartDataToDuplicate) return;
						postChart({ ...chartDataToDuplicate, name: `${chartDataToDuplicate.name} (${translateToString('dashboard.copy')})` }).then(() => {
							setRefreshMobileDashboard(!refreshMobileDashboard);
						});
					}}
				/>}
		</Popup>
		<Popup
			isOpen={!!maximiseChartPopupOpen}
			popupMode={PopupMode.Centered}
			popupStyle={{
				width: '80vw',
				height: '80vh',
				padding: '10px',
			}}
			onClickOut={() => setMaximiseChartPopupOpen(undefined)}
		>
			{maximiseChartPopupOpen && <MaximiseChartPopup props={maximiseChartPopupOpen.props} onClose={() => setMaximiseChartPopupOpen(undefined)} />}
		</Popup>
		<AllowDenyListPopup
			isOpen={restrictionModalState.isOpen}
			onClose={() => setRestrictionModalState({ isOpen: false })}
			objectActions={['ReadDashboard']}
			targetUuid={restrictionModalState.data}
		/>
		{innerDashboard}
	</Container>;
}

export function MobileDashboard() {
	return <Dashboards setToolBarState={() => undefined} isMobile />;
}
